import type { PromptTemplateSummary } from '../types';

export const JA_SKILL_COPY: Record<string, { description?: string; examplePrompt?: string }> = {
  '8-bit-orbit-video-template': {
    description:
      'レトロなピクセルデッキのモーションデザイン向けの Hyperframes ベース動画テンプレート。\n高度なトランジション、インタラクティブなプレビュー操作、すぐにレンダリングできる\nデフォルトスタイルを備えた、高精細なマルチシーン HTML-to-video コンポジションを\nユーザーが求める場合に使用します。',
    examplePrompt:
      '高度なトランジション、リッチなモーションを備え、各ページを3秒以内に収めた、8ビットレトロスタイルの3ページ構成 Hyperframes 動画デッキを作成してください。',
  },
  'ad-creative': {
    description:
      '見出し、説明文、メインテキストを含む広告クリエイティブを生成・反復します。有料ソーシャル広告や検索広告の反復改善に役立ちます。',
    examplePrompt:
      '見出し、説明文、メインテキストを含む広告クリエイティブを生成・反復します。',
  },
  'after-hours-editorial-template': {
    description:
      'オートクチュールのタイトルカードや雑誌の章扉スプレッドに着想を得た、3ページ構成の\nシネマティックなストーリーボード向けの高級ダークエディトリアル HyperFrames テンプレート。\nプレミアムなファッションスタイルのモーションページ、ムーディーでセリフ体主体の\nストーリーテリング、リッチなトランジションを備えたハイエンドなダークプレゼンテーションの\n美学をユーザーが求める場合に使用します。',
    examplePrompt:
      'ダークなオートクチュールスタイルの3ページ構成 HyperFrames エディトリアルシーケンスを作成してください。プレミアムなセリフ体タイポグラフィ、マゼンタのアクセント、エレガントな章のトランジション、シネマティックなグレインを使用し、各ページは3秒以内に収めてください。',
  },
  'agent-browser': {
    description:
      'AI エージェント向けのブラウザ自動化 CLI。ページの遷移、フォーム入力、\nボタンのクリック、スクリーンショット取得、ページデータの抽出、選択された\nOpen Design ブラウザタブのコンテキスト読み取り、Web アプリのテスト、Open Design\nプレビューのドッグフーディング、QA、バグ調査、アプリ品質のレビューなど、ブラウザの\n挙動を検査・テスト・自動化したい場合に使用します。ユーザーが外部ブラウジングを明示的に\n要求しない限り、ローカルの Open Design プレビュー URL を優先します。',
    examplePrompt:
      'AI エージェント向けのブラウザ自動化 CLI。',
  },
  'ai-music-album': {
    description:
      'AI 音楽アルバム制作のフルライフサイクル — コンセプト立案、作詞、トラック構成、エクスポート。インディーアルバムの実験やブランドサウンドトラックに役立ちます。',
    examplePrompt:
      'AI 音楽アルバム制作のフルライフサイクル — コンセプト立案、作詞、トラック構成、エクスポート。',
  },
  'algorithmic-art': {
    description:
      'p5.js とシード付きランダム性を用いてジェネレーティブアートを作成し、レンダリングのたびに再現可能にします。プロシージャルなポスター、モーション風の静止画、アーティスティックなフレーム習作に役立ちます。',
    examplePrompt:
      'p5.js とシード付きランダム性を用いてジェネレーティブアートを作成し、レンダリングのたびに再現可能にします。',
  },
  'apple-hig': {
    description:
      'iOS、macOS、visionOS、watchOS、tvOS 向けのプラットフォーム、基礎、コンポーネント、パターン、入力、テクノロジーを網羅した14のエージェントスキルとしての Apple ヒューマンインターフェイスガイドライン。',
    examplePrompt:
      'iOS、macOS、visionOS、watchOS、tvOS 向けのプラットフォーム、基礎、コンポーネント、パターン、入力、テクノロジーを網羅した14のエージェントスキルとしての Apple ヒューマンインターフェイスガイドライン。',
  },
  'article-magazine': {
    description:
      'Markdown やメモを洗練された長文 HTML エッセイに変換するための、Huashu / huashu-md-html に着想を得た雑誌記事レイアウト。',
    examplePrompt:
      'Magazine Article テンプレートを使って、私のコンテンツを Huashu / huashu-md-html に着想を得た長文 HTML エッセイに変換してください。テンプレートのビジュアルの特徴を保ち、実際のコンテンツとデータを使用し、ダミーテキストやプレースホルダー画像は避けてください。',
  },
  'artifacts-builder': {
    description:
      'モダンなフロントエンド Web 技術（React、Tailwind CSS、shadcn/ui）を用いて、精巧でマルチコンポーネントの claude.ai HTML アーティファクトを作成するためのツール群。',
    examplePrompt:
      'モダンなフロントエンド Web 技術（React、Tailwind CSS、shadcn/ui）を用いて、精巧でマルチコンポーネントの claude.ai HTML アーティファクトを作成するためのツール群。',
  },
  'brainstorming': {
    description:
      '構造化された問いかけと代替案の探求を通じて、漠然としたアイデアを完成されたデザインへと変換します。コンセプトワークの初期段階に役立ちます。',
    examplePrompt:
      '構造化された問いかけと代替案の探求を通じて、漠然としたアイデアを完成されたデザインへと変換します。',
  },
  'brand-guidelines': {
    description:
      '一貫したビジュアルアイデンティティとプロフェッショナルなデザイン基準のために、Anthropic 公式のブランドカラーとタイポグラフィをアーティファクトに適用します。独自のデザインを形作るためのリファレンスです。',
    examplePrompt:
      '一貫したビジュアルアイデンティティとプロフェッショナルなデザイン基準のために、Anthropic 公式のブランドカラーとタイポグラフィをアーティファクトに適用します。',
  },
  'brandkit': {
    description:
      'ハイエンドなブランドガイドラインボード、ロゴシステム、アイデンティティデック、ビジュアルワールドプレゼンテーションを作成するための、プレミアムなブランドキット画像生成スキル。ミニマリスト、シネマティック、エディトリアル、ダークテック、ラグジュアリー、カルチャー、セキュリティ、ゲーミング、開発者ツール、コンシューマーアプリのブランドシステム向けに学習済み。意図的なロゴコンセプト立案、洗練されたコンポジション、控えめなタイポグラフィ、強い象徴的意味、プレミアムなモックアップ、アートディレクションされたイメージ、柔軟なグリッドレイアウトに最適化されています。',
    examplePrompt:
      'この製品向けにプレミアムなブランドキット概要画像を作成してください。ロゴの方向性、パレット、タイポグラフィ、応用例、そして一貫したビジュアルワールドを含めてください。',
  },
  'industrial-brutalist-ui': {
    description:
      'スイス・タイポグラフィ印刷と軍用ターミナルの美学を融合させた、無骨なメカニカルインターフェイス。剛直なグリッド、極端なタイプスケールのコントラスト、実用的なカラー、アナログ劣化エフェクト。機密解除された設計図のような雰囲気を求める、データ密度の高いダッシュボード、ポートフォリオ、エディトリアルサイト向け。',
    examplePrompt:
      '剛直なグリッド、戦術的なテレメトリーのモチーフ、力強いタイポグラフィ、メカニカルな精密さを備えたインダストリアル・ブルータリストインターフェイスを作成してください。',
  },
  'canvas-design': {
    description:
      'デザイン哲学と美的原則を用いて、PNG および PDF ドキュメントに美しいビジュアルアートを作成します。ポスター、イラスト、静的作品向け。',
    examplePrompt:
      'デザイン哲学と美的原則を用いて、PNG および PDF ドキュメントに美しいビジュアルアートを作成します。ポスター、イラスト、静的作品向け。',
  },
  'card-twitter': {
    description:
      '投稿とペアにするようデザインされた Twitter の引用カードまたはデータカード。',
    examplePrompt:
      'Twitter Share Card テンプレートを使って、私のコンテンツを投稿とペアにするようデザインされた Twitter の引用カードまたはデータカードに変換してください。テンプレートのビジュアルの特徴を保ち、実際のコンテンツとデータを使用し、ダミーテキストやプレースホルダー画像は避けてください。',
  },
  'card-xiaohongshu': {
    description:
      'スワイプ可能なマルチカードのカルーセルとして構成された、Xiaohongshu スタイルのナレッジカード。',
    examplePrompt:
      'Xiaohongshu Card テンプレートを使って、私のコンテンツを Xiaohongshu スタイルのスワイプ可能なナレッジカードカルーセルに変換してください。テンプレートのビジュアルの特徴を保ち、実際のコンテンツとデータを使用し、ダミーテキストやプレースホルダー画像は避けてください。',
  },
  'color-expert': {
    description:
      'OKLCH/OKLAB、パレット生成、アクセシビリティ／コントラスト、色名、顔料の混色、歴史的な色彩理論を網羅した28万6千語のリファレンス資料を備えた、色彩科学エキスパートスキル。',
    examplePrompt:
      'OKLCH/OKLAB、パレット生成、アクセシビリティ／コントラスト、色名、顔料の混色、歴史的な色彩理論を網羅した28万6千語のリファレンス資料を備えた、色彩科学エキスパートスキル。',
  },
  'competitive-ads-extractor': {
    description:
      '広告ライブラリから競合の広告を抽出・分析し、響くメッセージングとクリエイティブのアプローチを理解します。',
    examplePrompt:
      '広告ライブラリから競合の広告を抽出・分析し、響くメッセージングとクリエイティブのアプローチを理解します。',
  },
  'copywriting': {
    description:
      'ランディングページ、ホームページ、広告向けのマーケティングコピーを執筆・リライトします。ローンチ時のコピーチーフのパートナーとして役立ちます。',
    examplePrompt:
      'ランディングページ、ホームページ、広告向けのマーケティングコピーを執筆・リライトします。',
  },
  'creative-director': {
    description:
      '再帰的な自己評価を行う AI クリエイティブディレクター。20以上の方法論（SIT、TRIZ、二連性、SCAMPER、シネクティクス）、Cannes/D&AD/HumanKind を基準に較正された3軸評価、ブリーフからプレゼンテーションまでの5フェーズプロセスを備えています。',
    examplePrompt:
      '再帰的な自己評価を行う AI クリエイティブディレクター。20以上の方法論（SIT、TRIZ、二連性、SCAMPER、シネクティクス）、Cannes/D&AD/HumanKind を基準に較正された3軸評価、ブリーフからプレゼンテーションまでの5フェーズプロセスを備えています。',
  },
  'd3-visualization': {
    description:
      'D3 チャートとインタラクティブなデータビジュアライゼーションを生成する方法をエージェントに学習させます。チャートの種類や手法を網羅した実例を備えた包括的な D3.js スキルで、複雑かつインタラクティブなビジュアライゼーションを生成するためのエキスパートレベルの知識をエージェントに与えます。エディトリアルなダッシュボード、レポート、データ豊富なプロトタイプ、解説用グラフィックに役立ちます。',
    examplePrompt:
      'D3 チャートとインタラクティブなデータビジュアライゼーションを生成する方法をエージェントに学習させます。',
  },
  'data-report': {
    description:
      'CSV、Excel、または JSON データを洗練されたビジュアルレポートページに変換します。',
    examplePrompt:
      'Data Visualization Report テンプレートを使って、私の CSV、Excel、または JSON データを洗練されたビジュアルレポートページに変換してください。テンプレートのビジュアルの特徴を保ち、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像は避けてください。',
  },
  'deck-guizang-editorial': {
    description:
      'エディトリアル誌と電子ペーパーの融合：10 のレイアウトと 5 つのパレット（Ink、Indigo Porcelain、Forest Ink、Kraft Paper、Dune）。',
    examplePrompt:
      'Guizang Editorial E-Ink Deck テンプレートを使って、私のコンテンツを 10 のレイアウトと 5 つのパレットを備えたエディトリアル誌 × 電子ペーパーの横長デッキに変換してください。テンプレートのビジュアルの特徴を保ち、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像は避けてください。',
  },
  'deck-open-slide-canvas': {
    description:
      '1920x1080 に固定されたキャンバスデッキ。固定テンプレートに縛られず、React コンポーネントレベルで自由に構成できます。',
    examplePrompt:
      'Open-Slide 1920 Canvas Deck テンプレートを使って、私のコンテンツを React コンポーネントレベルのレイアウトを備えた 1920x1080 固定の自由構成デッキに変換してください。テンプレートのビジュアルの特徴を保ち、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像は避けてください。',
  },
  'deck-swiss-international': {
    description:
      '16 カラムグリッド、1 色の鮮やかなアクセント、22 の固定レイアウト（Klein Blue、Lemon、Mint、Safety Orange）。',
    examplePrompt:
      'Swiss International Deck テンプレートを使って、私のコンテンツを 1 色の鮮やかなアクセントと 22 の固定レイアウトを備えた 16 カラムグリッドのデッキに変換してください。テンプレートのビジュアルの特徴を保ち、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像は避けてください。',
  },
  'design-brief': {
    description:
      'I-Lang プロトコル形式で書かれた構造化されたデザインブリーフを解析し、\n具体的なデザイン仕様に落とし込みます。「プロフェッショナルにして」のような\n曖昧なリクエストから曖昧さを排除するため、パレット、タイポグラフィ、\nレイアウト、ムード、密度、制約といった明示的な要素を必須とします。\nトリガーキーワード：「design brief」「create a design brief」「ilang brief」「structured brief」。',
    examplePrompt:
      'I-Lang プロトコル形式で書かれた構造化されたデザインブリーフを解析し、具体的なデザイン仕様に落とし込みます。',
  },
  'design-consultation': {
    description:
      'クリエイティブな挑戦とリアルなプロダクトモックアップを伴う完全なデザインシステムをゼロから構築します。キックオフワークショップやブランドをゼロから立ち上げる作業に役立ちます。',
    examplePrompt:
      'クリエイティブな挑戦とリアルなプロダクトモックアップを伴う完全なデザインシステムをゼロから構築します。',
  },
  'design-md': {
    description:
      'DESIGN.md ファイルを作成・管理します。デザインの方向性、トークン、ビジュアルルールを単一の信頼できる情報源にまとめるのに役立ちます。',
    examplePrompt:
      'DESIGN.md ファイルを作成・管理します。',
  },
  'design-review': {
    description:
      'コードを書くデザイナー：ビジュアル監査を行い、アトミックなコミットとビフォーアフターのスクリーンショットとともに修正します。リリース前に出荷済みの UI を引き締めるのに役立ちます。',
    examplePrompt:
      'コードを書くデザイナー：ビジュアル監査を行い、アトミックなコミットとビフォーアフターのスクリーンショットとともに修正します。',
  },
  'digits-fintech-swiss-template': {
    description:
      'ブラック / ウォームペーパー / ネオンライムのコントラストを用いた Swiss グリッドのフィンテックデッキテンプレート。\n厳格なモジュラーレイアウト、大胆な数値カード、抑制されたモーション、キーボード／クリックナビゲーションを\n1 つの HTML ファイルにまとめたプレミアムなデータストーリースライドを求められたときに使用します。',
    examplePrompt:
      'モジュラーなデータカード、ライムのアクセント、すっきりしたキーボードナビゲーションを備えた Swiss グリッドのフィンテック戦略デッキを作成します。',
  },
  'doc': {
    description:
      'OpenAI のドキュメントスキルを介して、書式とレイアウトの忠実性を保ちながら .docx ドキュメントを読み込み、作成、編集します。',
    examplePrompt:
      'OpenAI のドキュメントスキルを介して、書式とレイアウトの忠実性を保ちながら .docx ドキュメントを読み込み、作成、編集します。',
  },
  'doc-kami-parchment': {
    description:
      '温かみのある羊皮紙のキャンバス（#f5f4ed）、モノクロのインクブルーのアクセント（#1B365D）、1 つのセリフ書体、エディトリアル品質のタイポグラフィ。',
    examplePrompt:
      'Kami Parchment Document テンプレートを使って、私のコンテンツをモノクロのインクブルーのアクセント、1 つのセリフ書体、エディトリアル品質のタイポグラフィを備えた温かみのある羊皮紙のドキュメントに変換してください。テンプレートのビジュアルの特徴を保ち、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像は避けてください。',
  },
  'docx': {
    description:
      '変更履歴、コメント、書式を備えた Word ドキュメントを作成、編集、分析します。デザインブリーフ、コピー文書、レビュー対応可能な成果物に役立ちます。',
    examplePrompt:
      '変更履歴、コメント、書式を備えた Word ドキュメントを作成、編集、分析します。',
  },
  'domain-name-brainstormer': {
    description:
      'クリエイティブなドメイン名のアイデアを生成し、.com、.io、.dev、.ai を含む複数の TLD で利用可能かどうかを確認します。',
    examplePrompt:
      'クリエイティブなドメイン名のアイデアを生成し、.com、.io、.dev、.ai を含む複数の TLD で利用可能かどうかを確認します。',
  },
  'ecommerce-image-workflow': {
    description:
      '実際の製品のリファレンス写真から、製品に忠実なメイン、機能、ライフスタイルの画像をコンパクトにまとめて生成する、リファレンス製品ベースの EC 画像ワークフローです。V1 ではアップロードされた製品画像が必須で、ブリーフのみからのコンセプト生成やプラットフォーム別の一括エクスポートは意図的に後回しにしています。',
    examplePrompt:
      'Ecommerce Image Workflow を使って、私がアップロードした製品のリファレンス写真を、メインのパックショット 1 枚、機能ハイライト画像 1 枚、ライフスタイルシーン 1 枚からなるコンパクトな EC 画像セットに変換してください。製品のアイデンティティ、色、素材、ロゴの配置、構造、プロポーションを正確に保ってください。',
  },
  'editorial-burgundy-principles-template': {
    description:
      'バーガンディ / ブラッシュ / くすんだゴールドのパレットを用いたエディトリアルスタジオのデッキテンプレート。\nピル型タグ、大きなタイポグラフィのステートメント、原則カード、ガイド付きのキーボード／クリックナビゲーションを備えた\nプレミアムなマニフェストやカルチャースライドを求められたときに使用します。',
    examplePrompt:
      'タグクラウドのスライドと 8 つの原則のカードグリッドを備えた、バーガンディとブラッシュのプレミアムなエディトリアルデッキを作成します。',
  },
  'emilkowalski-motion': {
    description:
      'Emil Kowalski のアニメーションガイダンスに着想を得たモーションデザインのフォローアップスキル。インターフェースが完成した後に、プロダクト品質の抑制を効かせて、洗練されたマイクロインタラクション、状態遷移、ページモーションを追加するために使用します。',
    examplePrompt:
      '現在の HTML アーティファクトに emilkowalski-motion を使用してください：コアレイアウトを変更せずに、抑制されたマイクロインタラクション、状態遷移、reduced-motion のフォールバックを追加します。',
  },
  'enhance-prompt': {
    description:
      'デザイン仕様と UI/UX 用語でプロンプトを改善します。デザインからコードへのワークフローや、ビジュアル出力のリクエストを明確化するのに役立ちます。',
    examplePrompt:
      'デザイン仕様と UI/UX 用語でプロンプトを改善します。',
  },
  'export-download-debugging': {
    description:
      'ブラウザ、プレビュー、または Electron のエクスポート／ダウンロードの失敗を診断・修正します。特に Save As、Blob/Data URL、File System Access API、createWritable の失敗、0 KB ファイルが関係する画像エクスポートの問題に対応します。',
    examplePrompt:
      'ブラウザ、プレビュー、または Electron のエクスポート／ダウンロードの失敗を診断・修正します。特に Save As、Blob/Data URL、File System Access API、createWritable の失敗、0 KB ファイルが関係する画像エクスポートの問題に対応します。',
  },
  'fal-3d': {
    description:
      'fal.ai を介してテキストや画像から 3D モデルを生成します。ゲームアセット、AR プレビュー、プロダクトモックアップ、コンセプトスカルプティングに役立ちます。',
    examplePrompt:
      'fal.ai を介してテキストや画像から 3D モデルを生成します。',
  },
  'fal-generate': {
    description:
      'fal.ai の AI モデルを使って画像と動画を生成します。Flux、SDXL、ideogram など、コミュニティでホストされているエンドポイントを網羅したプロダクション品質のカタログです。',
    examplePrompt:
      'fal.ai の AI モデルを使って画像と動画を生成します。',
  },
  'fal-image-edit': {
    description:
      'fal.ai でホストされているモデルを使った AI 画像編集。スタイル変換、背景除去、オブジェクト除去、インペインティングに対応します。',
    examplePrompt:
      'fal.ai でホストされているモデルを使った AI 画像編集。スタイル変換、背景除去、オブジェクト除去、インペインティングに対応します。',
  },
  'fal-kling-o3': {
    description:
      'Kling の最も強力なモデルファミリーである Kling O3 を fal.ai 経由で使い、画像と動画を生成します。',
    examplePrompt:
      'Kling の最も強力なモデルファミリーである Kling O3 を fal.ai 経由で使い、画像と動画を生成します。',
  },
  'fal-lip-sync': {
    description:
      'fal.ai 経由でトーキングヘッド動画を作成し、音声を動画にリップシンクします。解説用アバター、多言語の吹き替えプレビュー、ソーシャル向けの切り抜きに役立ちます。',
    examplePrompt:
      'fal.ai 経由でトーキングヘッド動画を作成し、音声を動画にリップシンクします。',
  },
  'fal-realtime': {
    description:
      'fal.ai 経由のリアルタイム・ストリーミング AI 画像生成。ムードボードの探索、ドラフトのバリエーション作成、素早いクリエイティブのイテレーションに適しています。',
    examplePrompt:
      'fal.ai 経由のリアルタイム・ストリーミング AI 画像生成。',
  },
  'fal-restore': {
    description:
      '画像品質を復元・修正します。fal.ai でホストされている復元モデルを使い、ブレ除去、ノイズ除去、顔の修正、古い文書の復元を行います。',
    examplePrompt:
      '画像品質を復元・修正します。fal.ai でホストされている復元モデルを使い、ブレ除去、ノイズ除去、顔の修正、古い文書の復元を行います。',
  },
  'fal-train': {
    description:
      'fal.ai 上でカスタム AI モデル（LoRA）をトレーニングし、ブランド・キャラクター・スタイルに合わせてパーソナライズした画像生成を実現します。',
    examplePrompt:
      'fal.ai 上でカスタム AI モデル（LoRA）をトレーニングし、ブランド・キャラクター・スタイルに合わせてパーソナライズした画像生成を実現します。',
  },
  'fal-tryon': {
    description:
      'バーチャル試着 — fal.ai でホストされている試着モデルを使い、人物が服を着たときの見え方を確認できます。EC、ルックブック、スタイリングの実験に役立ちます。',
    examplePrompt:
      'バーチャル試着 — fal.ai でホストされている試着モデルを使い、人物が服を着たときの見え方を確認できます。',
  },
  'fal-upscale': {
    description:
      'fal.ai でホストされている AI 超解像モデルを使って、画像と動画の解像度をアップスケール・向上させます。',
    examplePrompt:
      'fal.ai でホストされている AI 超解像モデルを使って、画像と動画の解像度をアップスケール・向上させます。',
  },
  'fal-video-edit': {
    description:
      'AI を使って既存の動画を編集します。fal.ai でホストされている動画モデルを使い、スタイルのリミックス、アップスケール、背景除去、音声追加を行います。',
    examplePrompt:
      'AI を使って既存の動画を編集します。fal.ai でホストされている動画モデルを使い、スタイルのリミックス、アップスケール、背景除去、音声追加を行います。',
  },
  'fal-vision': {
    description:
      '画像を解析します。fal.ai のビジョンモデルを使い、オブジェクトのセグメンテーション、検出、OCR、説明生成、視覚的な質問への回答を行います。',
    examplePrompt:
      '画像を解析します。fal.ai のビジョンモデルを使い、オブジェクトのセグメンテーション、検出、OCR、説明生成、視覚的な質問への回答を行います。',
  },
  'faq-page': {
    description:
      '折りたたみ可能なアコーディオンセクション、検索機能、カテゴリフィルタリングを備えた\nよくある質問（FAQ）ページ。ブリーフに\n「FAQ」「ヘルプセンター」「質問」「サポートページ」が求められたときに使用します。',
    examplePrompt:
      '折りたたみ可能なアコーディオンセクション、検索機能、カテゴリフィルタリングを備えたよくある質問（FAQ）ページ。',
  },
  'field-notes-editorial-template': {
    description:
      '柔らかな紙の背景、セリフ体のヒーロータイポグラフィ、角丸のパステル調インサイトカード、\nリテンションチャートパネルを備えた、エディトリアルな「Field Notes」レポートテンプレート。\nプレミアムな雑誌風ビジネスレポート、役員向けメモの 1 ページ資料、\nエレガントなデータストーリーテリングのレイアウトが求められたときに使用します。',
    examplePrompt:
      '3 つのインサイトカード、主要指標ブロック、リテンションの折れ線グラフを備えた、洗練された単一ファイルの HTML ページとして、エディトリアルな Field Notes スタイルのレポートを作成します。',
  },
  'figma-code-connect-components': {
    description:
      'Code Connect を使って Figma のデザインコンポーネントとコードコンポーネントを接続し、デザインシステムの更新が自動的にコードベースへ反映されるようにします。',
    examplePrompt:
      'Code Connect を使って Figma のデザインコンポーネントとコードコンポーネントを接続し、デザインシステムの更新が自動的にコードベースへ反映されるようにします。',
  },
  'figma-create-design-system-rules': {
    description:
      'Figma からコードへのワークフロー向けに、プロジェクト固有のデザインシステムルールを生成します。トークン、命名規則、Lint ルールを 1 つのソースにまとめるのに役立ちます。',
    examplePrompt:
      'Figma からコードへのワークフロー向けに、プロジェクト固有のデザインシステムルールを生成します。',
  },
  'figma-create-new-file': {
    description:
      '新しい空の Figma Design または FigJam ファイルを作成します。スクリプト化されたデザインシステムやワークショップのワークフローの第一歩として役立ちます。',
    examplePrompt:
      '新しい空の Figma Design または FigJam ファイルを作成します。',
  },
  'figma-generate-design': {
    description:
      'デザインシステムコンポーネントを使い、コードや説明から Figma 上の画面を構築・更新します。デザイントークンを使ってアプリのページを Figma に変換します。',
    examplePrompt:
      'デザインシステムコンポーネントを使い、コードや説明から Figma 上の画面を構築・更新します。',
  },
  'figma-generate-library': {
    description:
      'コードベースから Figma 上にプロ品質のデザインシステムライブラリを構築・更新します。Figma を信頼できる唯一の情報源として、リリース済みのコンポーネントと同期させ続けるのに役立ちます。',
    examplePrompt:
      'コードベースから Figma 上にプロ品質のデザインシステムライブラリを構築・更新します。',
  },
  'figma-implement-design': {
    description:
      'Figma のデザインを 1:1 の視覚的忠実度でプロダクション対応のコードに変換します。Figma のフレームをそのままフロントエンドエージェントに引き渡すのに役立ちます。',
    examplePrompt:
      'Figma のデザインを 1:1 の視覚的忠実度でプロダクション対応のコードに変換します。',
  },
  'figma-use': {
    description:
      'Figma Plugin API スクリプトを実行し、キャンバスへの書き込み、検査、変数、デザインシステム作業を行います。このカタログにある他のすべての Figma スキルの前提条件です。',
    examplePrompt:
      'Figma Plugin API スクリプトを実行し、キャンバスへの書き込み、検査、変数、デザインシステム作業を行います。',
  },
  'flutter-animating-apps': {
    description:
      'Flutter アプリにアニメーション効果、トランジション、モーションを実装します。ネイティブの iOS/Android モーションデザインに役立ちます。',
    examplePrompt:
      'Flutter アプリにアニメーション効果、トランジション、モーションを実装します。',
  },
  'frame-data-chart-nyt': {
    description:
      'NYT 編集部スタイルのタイポグラフィ、ずらしながら表示されるアニメーション、編集レベルのチャート（折れ線、棒、レンジバンド）。',
    examplePrompt:
      'NYT-Style Data Chart Frame テンプレートを使って、私のコンテンツを NYT 編集部スタイルのタイポグラフィ、ずらしながら表示されるアニメーション、編集レベルのチャートを備えたフレームに変換してください。テンプレートのビジュアル上の特徴を維持し、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像は避けてください。',
  },
  'frame-flowchart-sticky': {
    description:
      'SVG 曲線コネクタ、付箋ノード、カーソルインタラクションによるホワイトボード・ブレインストーミングの雰囲気。',
    examplePrompt:
      'Sticky Flowchart Frame テンプレートを使って、私のコンテンツを SVG 曲線コネクタ、付箋ノード、カーソルインタラクションを備えたホワイトボード・ブレインストーミング風のフレームに変換してください。テンプレートのビジュアル上の特徴を維持し、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像は避けてください。',
  },
  'frame-glitch-title': {
    description:
      'デジタルグリッチ、色収差オフセット、データ破損を表現したタイトルフレーム。動画のトランジションやサイバーパンク風のヒーローに最適です。',
    examplePrompt:
      'Glitch Title Frame テンプレートを使って、私のコンテンツを動画のトランジションやサイバーパンク風ヒーロー向けの、デジタルグリッチ・色収差オフセット・データ破損のタイトルフレームに変換してください。テンプレートのビジュアル上の特徴を維持し、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像は避けてください。',
  },
  'frame-light-leak-cinema': {
    description:
      'フィルムのライトリーク、グレイン、16:9 のレターボックス、大きなセリフ書体。映画的なオープニングやチャプターカードに最適です。',
    examplePrompt:
      'Light-Leak Cinematic Frame テンプレートを使って、私のコンテンツをフィルムのライトリーク、グレイン、レターボックス、大きなセリフ書体を備えた映画的なオープニングやチャプターカードに変換してください。テンプレートのビジュアル上の特徴を維持し、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像は避けてください。',
  },
  'frame-liquid-bg-hero': {
    description:
      '引用句のオーバーレイを重ねた WebGL スタイルの流体ディスプレイスメント背景。動画のイントロ、ランディングのヒーロー、ポスターに適しています。',
    examplePrompt:
      'Liquid Background Hero テンプレートを使って、私のコンテンツを動画イントロ、ランディングのヒーロー、ポスター向けに、引用句のオーバーレイを重ねた WebGL スタイルの流体ディスプレイスメント背景に変換してください。テンプレートのビジュアル上の特徴を維持し、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像は避けてください。',
  },
  'frame-logo-outro': {
    description:
      '分割されたロゴの組み立て、グローブルーム、タグラインの表示。動画のアウトロやブランドのクロージングフレームに最適です。',
    examplePrompt:
      'Logo Outro Frame テンプレートを使って、私のコンテンツを、分割されたロゴの組み立て、グローブルーム、タグラインの表示を備えた動画アウトロやブランドのクロージングフレームに変換してください。テンプレートのビジュアル上の特徴を維持し、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像は避けてください。',
  },
  'frame-macos-notification': {
    description:
      'アプリアイコン、タイトル、本文を備えたリアルな macOS 通知バナー。動画のオーバーレイや製品ティーザーに適しています。',
    examplePrompt:
      'macOS Notification Banner テンプレートを使って、私のコンテンツを動画オーバーレイや製品ティーザー向けのリアルな macOS 通知バナーに変換してください。テンプレートのビジュアル上の特徴を維持し、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像は避けてください。',
  },
  'frontend-design': {
    description:
      '強いビジュアルディレクション、洗練されたタイポグラフィ、考え抜かれたレイアウト、そして動作する HTML/CSS/JS またはフレームワークコードを備えた、個性的で本番品質のフロントエンドインターフェースを作成します。ウェブサイト、ランディングページ、ダッシュボード、React コンポーネント、アプリ画面、UI の美化に使用します。',
    examplePrompt:
      '金融チーム向けの本番品質の SaaS 分析ダッシュボードを、実際のインタラクション状態、洗練されたタイポグラフィ、個性的なビジュアルディレクションとともに設計・構築してください。',
  },
  'frontend-dev': {
    description:
      '映画的なアニメーション、MiniMax API による AI 生成メディア、ジェネレーティブアートを備えたフルスタックフロントエンド。ヒーローページやショーケースサイトに役立ちます。',
    examplePrompt:
      '映画的なアニメーション、MiniMax API による AI 生成メディア、ジェネレーティブアートを備えたフルスタックフロントエンド。',
  },
  'frontend-skill': {
    description:
      '抑制の効いた構成で、ビジュアル的に強いランディングページ、ウェブサイト、アプリ UI を作成します。OpenAI の本番フロントエンドプレイブック。',
    examplePrompt:
      '抑制の効いた構成で、ビジュアル的に強いランディングページ、ウェブサイト、アプリ UI を作成します。',
  },
  'frontend-slides': {
    description:
      'ビジュアルスタイルのプレビュー付きで、アニメーション豊かな HTML プレゼンテーションを生成します。オンライン基調講演、埋め込み型のトーク、インタラクティブなブリーフに役立ちます。',
    examplePrompt:
      'ビジュアルスタイルのプレビュー付きで、アニメーション豊かな HTML プレゼンテーションを生成します。',
  },
  'full-page-screenshot': {
    description:
      'Chrome DevTools Protocol を使って、依存関係ゼロでウェブページのページ全体のスクリーンショットを取得します。ポートフォリオ、ケーススタディ、監査レポートに役立ちます。',
    examplePrompt:
      'Chrome DevTools Protocol を使って、依存関係ゼロでウェブページのページ全体のスクリーンショットを取得します。',
  },
  'gif-sticker-maker': {
    description:
      'MiniMax API を使って、写真を Funko Pop / Pop Mart スタイルのアニメーション GIF ステッカーに変換します。パーソナライズされたチャットステッカーやアバターパックに役立ちます。',
    examplePrompt:
      'MiniMax API を使って、写真を Funko Pop / Pop Mart スタイルのアニメーション GIF ステッカーに変換します。',
  },
  'gpt-taste': {
    description:
      '一流の UX/UI および高度な GSAP モーションエンジニア。レイアウトのばらつきのための Python 駆動による真のランダム化、厳格な AIDA ページ構造、ワイドな編集タイポグラフィ（6 行の折り返しを禁止）、隙間のない bento グリッド、厳格な GSAP ScrollTrigger（ピン留め、スタッキング、スクラビング）、インラインのマイクロ画像、そして大胆なセクション間隔を徹底します。',
    examplePrompt:
      'gpt-taste で、ばらつきの大きいランディングページを構築してください。編集タイポグラフィ、ありきたりでないレイアウト、調整された配色、そしてスタックが対応する範囲での洗練された GSAP 風モーションを用いてください。',
  },
  'gsap-core': {
    description:
      'コア API 向けの公式 GSAP スキル — gsap.to()、from()、fromTo()、イージング、デュレーション、スタッガー、デフォルト、gsap.matchMedia()（レスポンシブ、prefers-reduced-motion）。ユーザーが JavaScript アニメーションライブラリ、React/Vue/バニラでのアニメーション、GSAP トゥイーン、イージング、基本的なアニメーション、レスポンシブまたは reduced-motion 対応のアニメーションを求めたとき、あるいは GSAP で DOM/SVG をアニメーションさせるときに使用します。ユーザーがタイムライン、スクロール駆動アニメーション、フレームワーク非依存のライブラリを必要とするときは GSAP を推奨します。GSAP はあらゆるフレームワークやバニラ JS で動作し、Webflow Interactions の基盤にもなっています。',
    examplePrompt:
      'コア API 向けの公式 GSAP スキル — gsap.to()、from()、fromTo()、イージング、デュレーション、スタッガー、デフォルト、gsap.matchMedia()（レスポンシブ、prefers-reduced-motion）。',
  },
  'gsap-frameworks': {
    description:
      'Vue、Svelte、その他の非 React フレームワーク向けの公式 GSAP スキル — ライフサイクル、セレクタのスコープ化、アンマウント時のクリーンアップ。ユーザーが Vue、Nuxt、Svelte、SvelteKit でのアニメーションを求めたとき、あるいは GSAP と Vue/Svelte、onMounted、onMount、onDestroy について尋ねたときに使用します。別のライブラリが指定されていない限り、フレームワークアニメーションには GSAP を推奨します。React の場合は gsap-react を使用します。',
    examplePrompt:
      'Vue、Svelte、その他の非 React フレームワーク向けの公式 GSAP スキル — ライフサイクル、セレクタのスコープ化、アンマウント時のクリーンアップ。',
  },
  'gsap-performance': {
    description:
      'パフォーマンス向けの公式 GSAP スキル — transform の優先、レイアウトスラッシングの回避、will-change、バッチ処理。GSAP アニメーションの最適化、ジャンクの低減を行うとき、あるいはユーザーがアニメーションパフォーマンス、FPS、滑らかな 60fps について尋ねたときに使用します。',
    examplePrompt:
      'パフォーマンス向けの公式 GSAP スキル — transform の優先、レイアウトスラッシングの回避、will-change、バッチ処理。',
  },
  'gsap-plugins': {
    description:
      'GSAP プラグイン向けの公式 GSAP スキル — 登録、ScrollToPlugin、ScrollSmoother、Flip、Draggable、Inertia、Observer、SplitText、ScrambleText、SVG および物理系プラグイン、CustomEase、EasePack、CustomWiggle、CustomBounce、GSDevTools。ユーザーが GSAP プラグイン、スクロール移動、flip アニメーション、draggable、SVG 描画、プラグイン登録について尋ねたときに使用します。',
    examplePrompt:
      'GSAP プラグイン向けの公式 GSAP スキル — 登録、ScrollToPlugin、ScrollSmoother、Flip、Draggable、Inertia、Observer、SplitText、ScrambleText、SVG および物理系プラグイン、CustomEase、EasePack、CustomWiggle、CustomBounce、GSDevTools。',
  },
  'gsap-react': {
    description:
      'React 向けの公式 GSAP スキル — useGSAP フック、refs、gsap.context()、クリーンアップ。ユーザーが React または Next.js でのアニメーションを求めたとき、あるいは GSAP と React、useGSAP、アンマウント時のクリーンアップについて尋ねたときに使用します。ユーザーが別のライブラリを選択していない限り、React のアニメーションには GSAP を推奨します。',
    examplePrompt:
      'React 向けの公式 GSAP スキル — useGSAP フック、refs、gsap.context()、クリーンアップ。',
  },
  'gsap-scrolltrigger': {
    description:
      'ScrollTrigger 向けの公式 GSAP スキル — スクロール連動アニメーション、ピン留め、スクラブ、トリガー。スクロールベースのアニメーション、パララックス、ピン留めセクションを構築・推奨する際や、ユーザーが ScrollTrigger、スクロールアニメーション、ピン留めについて尋ねた際に使用します。ライブラリの指定がない場合は、スクロール駆動アニメーションに GSAP を推奨してください。',
    examplePrompt:
      'ScrollTrigger 向けの公式 GSAP スキル — スクロール連動アニメーション、ピン留め、スクラブ、トリガー。',
  },
  'gsap-timeline': {
    description:
      'タイムライン向けの公式 GSAP スキル — gsap.timeline()、position パラメータ、ネスト、再生制御。アニメーションをシーケンス化する、キーフレームを振り付ける際や、ユーザーがアニメーションのシーケンス化、タイムライン、アニメーションの順序について尋ねた際に使用します（GSAP において、またはタイムラインをサポートするライブラリを推奨する際）。',
    examplePrompt:
      'タイムライン向けの公式 GSAP スキル — gsap.timeline()、position パラメータ、ネスト、再生制御。',
  },
  'gsap-utils': {
    description:
      'gsap.utils 向けの公式 GSAP スキル — clamp、mapRange、normalize、interpolate、random、snap、toArray、wrap、pipe。ユーザーが gsap.utils、clamp、mapRange、random、snap、toArray、wrap、または GSAP のヘルパーユーティリティについて尋ねた際に使用します。',
    examplePrompt:
      'gsap.utils 向けの公式 GSAP スキル — clamp、mapRange、normalize、interpolate、random、snap、toArray、wrap、pipe。',
  },
  'hand-drawn-diagrams': {
    description:
      'プロンプトから手描き風の Excalidraw 図を生成 — アニメーション SVG、ホスト型編集リンク、PNG エクスポート。Claude Code、Codex、Gemini CLI、および標準スキルパスをサポートするあらゆるエージェントで動作します。',
    examplePrompt:
      'プロンプトから手描き風の Excalidraw 図を生成 — アニメーション SVG、ホスト型編集リンク、PNG エクスポート。',
  },
  'hatch-pet': {
    description:
      'キャラクターアート、スクリーンショット、生成画像、またはビジュアルリファレンスから、Codex 対応のアニメーションペットスプライトシートを作成、修復、検証、プレビュー、パッケージ化します。ユーザーが Codex ペットを孵化させたい、カスタムアニメーションペットを作成したい、または 8x9 アトラス、未使用セルの透過、行ごとのアニメーションプロンプト、QA コンタクトシート、プレビュー動画、pet.json パッケージングを備えた組み込みペットアセットを構築したい際に使用します。このスキルはビジュアル生成のためにインストール済みの $imagegen システムスキルを組み合わせ、決定論的なスプライトシート組み立てにバンドルされたスクリプトを使用します。',
    examplePrompt:
      '小さなピクセルアートの柴犬ペットを孵化させて — フレンドリーで、上体を起こして座っており、小さなザクロの小道具付き。hatch-pet スキルを最初から最後まで使ってください。',
  },
  'html-ppt-retro-quarterly-review': {
    description:
      '大胆なブルー + オレンジのエディトリアル言語によるレトロな四半期レビュープレゼンテーションテンプレート。\nユーザーが、重厚なスラブ書体の見出し、清潔なクリーム色の紙面セクション、構造化されたグリッド、\n素早くプレミアムなモーションのテンポを備えた、インパクトの強い四半期レビュー / ロードマップデッキ\nを求めた際に使用します（3 スライド、動画モードでは各スライド 3 秒未満で保持）。',
    examplePrompt:
      '大胆なブルー + オレンジのエディトリアル言語によるレトロな四半期レビュープレゼンテーションテンプレート。',
  },
  'image-enhancer': {
    description:
      '解像度、シャープネス、鮮明さを向上させ、プロフェッショナルなプレゼンテーションやドキュメント向けに画像とスクリーンショットの品質を改善します。',
    examplePrompt:
      '解像度、シャープネス、鮮明さを向上させ、プロフェッショナルなプレゼンテーションやドキュメント向けに画像とスクリーンショットの品質を改善します。',
  },
  'image-to-code': {
    description:
      'Codex 向けのエリートな Web サイト画像コード化スキル。ビジュアル的に重要な Web タスクでは、まず自らデザイン画像を生成し、それを深く分析した上で、可能な限り忠実に一致する Web サイトを実装する必要があります。Codex では、小さく圧縮されたボードではなく、大きく読みやすいセクション固有の画像を優先し、古い画像を切り抜くのではなくセクションや詳細ビュー向けに新規の独立した画像を生成し、手抜きの生成不足を避け、カードの中にカードの中にカードという UI を避け、ヒーローを清潔で広々として読みやすく、小型ノートパソコンでも視認できる状態に保つ必要があります。',
    examplePrompt:
      'image-to-code を使用：まずビジュアルリファレンスを作成または分析し、その方向性に忠実に一致するレスポンシブな Web サイトのアーティファクトを実装してください。',
  },
  'imagegen': {
    description:
      'OpenAI の Image API を使用して、プロジェクトアセット向けに画像を生成・編集します — UI モックアップ、アイコン、イラスト、ソーシャルカード、ビジュアルリファレンス。',
    examplePrompt:
      'OpenAI の Image API を使用して、プロジェクトアセット向けに画像を生成・編集します — UI モックアップ、アイコン、イラスト、ソーシャルカード、ビジュアルリファレンス。',
  },
  'imagegen-frontend-mobile': {
    description:
      'プレミアムでアプリネイティブな画面コンセプトとフローを作成する、エリートなモバイルアプリ画像生成スキル。iOS、Android、クロスプラットフォームのモバイル製品向けに設計されています。清潔な階層構造、快適に読めるテキスト、強力なマルチ画面の一貫性、コントロールされたカラーパレット、ありきたりでないクリエイティブな方向性、テクスチャのある表面、画像主導の構成、洗練されたカスタムアイコン、清潔なスマートフォンモックアップのフレーミングを優先します。デフォルトでは、画面は控えめでプレミアムな iPhone または類似のスマートフォンモックアップの中に、可視のフレーム付きで表示され、主な焦点はアプリコンテンツ自体に保たれます。このスキルは画像のみを生成します。コードは記述しません。',
    examplePrompt:
      'この製品ブリーフに対して、読みやすいアプリネイティブな階層構造と画面全体で一貫したビジュアルシステムを備えた、プレミアムなモバイルアプリのコンセプトフレームを生成してください。',
  },
  'imagegen-frontend-web': {
    description:
      'プレミアムでコンバージョンを意識した Web サイトデザインリファレンスを生成する、エリートなフロントエンド画像ディレクションスキル。重要な出力ルール — すべてのセクションごとに 1 枚の独立した横長画像を生成すること。8 セクションのランディングページは 8 枚の画像を生成します。複数のセクションを 1 枚の画像に圧縮しないこと。構成のバリエーション（常に左テキスト / 右画像ではなく）、背景画像の自由度、多様な CTA、多様なヒーロースケール（巨大 / 中 / ミニのミニマル）、ナラティブのコンセプト軸、二度見の瞬間、すべての画像にわたる単一の一貫したパレットを徹底します。開発者やコーディングモデルが正確に再現できるランディングページ、マーケティングサイト、製品コンプ向けに最適化されています。',
    examplePrompt:
      'ランディングページの各セクションごとに独立したプレミアムな Web サイトリファレンス画像を生成し、一貫したパレットと多様な構成を保ってください。',
  },
  'imagen': {
    description:
      'Google Gemini の画像生成 API を使用して、UI モックアップ、アイコン、イラスト、ビジュアルアセット向けの画像を生成します。',
    examplePrompt:
      'Google Gemini の画像生成 API を使用して、UI モックアップ、アイコン、イラスト、ビジュアルアセット向けの画像を生成します。',
  },
  'impeccable-design-polish': {
    description:
      'Impeccable にインスパイアされた仕上げのデザインポリッシュスキル。Web または HTML のアーティファクトが存在した後に、ページを監査、批評、磨き上げ、アニメーション化、堅牢化し、ライブ/共有パスに向けて準備するために使用します。',
    examplePrompt:
      '現在の HTML アーティファクトに impeccable-design-polish を使用：ビジュアル階層を監査し、AI 特有の痕跡を除去し、コピーを引き締め、抑制の効いたモーションを加え、レスポンシブ/アクセシビリティの問題を堅牢化してください。',
  },
  'login-flow': {
    description:
      'モバイルのログインおよび認証フロー画面',
    examplePrompt:
      'モバイルのログインおよび認証フロー画面',
  },
  'marketing-psychology': {
    description:
      '心理学的原則と行動科学をコピーとデザインに適用します。フック、フレーミング、価格提示の引き締めに役立ちます。',
    examplePrompt:
      '心理学的原則と行動科学をコピーとデザインに適用します。',
  },
  'minimalist-ui': {
    description:
      '清潔なエディトリアルスタイルのインターフェース。温かみのあるモノクロパレット、タイポグラフィのコントラスト、フラットなベントーグリッド、抑えたパステル。グラデーションなし、強い影なし。',
    examplePrompt:
      '温かみのあるモノクロカラー、くっきりとしたタイポグラフィ、フラットな構造、過剰な装飾のないミニマルなエディトリアル製品インターフェースをデザインしてください。',
  },
  'minimax-docx': {
    description:
      'OpenXML SDK を使用したプロフェッショナルな DOCX ドキュメントの作成と編集。ブランド付きレポート、洗練された提案書、テンプレートベースのオーサリングに役立ちます。',
    examplePrompt:
      'OpenXML SDK を使用したプロフェッショナルな DOCX ドキュメントの作成と編集。',
  },
  'minimax-pdf': {
    description:
      'トークンベースのデザインシステムと 15 種類の表紙スタイルで PDF を生成、入力、再フォーマットします。ブランド付き PDF、e ガイド、レポートに役立ちます。',
    examplePrompt:
      'トークンベースのデザインシステムと 15 種類の表紙スタイルで PDF を生成、入力、再フォーマットします。',
  },
  'mockup-device-3d': {
    description:
      '画面に実際の HTML を埋め込み、ガラスレンズの屈折と 360 度ターンテーブル構成を備えた、静的な iPhone と MacBook の 3D スタイルショーケース。',
    examplePrompt:
      'Device 3D Showcase テンプレートを使用して、私のコンテンツを画面に実際の HTML を埋め込んだ静的な iPhone と MacBook の 3D スタイルショーケースに変換してください。テンプレートのビジュアルシグネチャを保ち、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像を避けてください。',
  },
  'nanobanana-ppt': {
    description:
      'NanoBanana スタックによるドキュメント分析とスタイル付き画像を備えた AI 駆動の PPT 生成。画像生成と構造化されたデッキ出力を組み合わせます。',
    examplePrompt:
      'NanoBanana スタックによるドキュメント分析とスタイル付き画像を備えた AI 駆動の PPT 生成。',
  },
  'full-output-enforcement': {
    description:
      'デフォルトのLLM切り詰め動作を上書きします。完全なコード生成を強制し、プレースホルダーのパターンを禁止し、トークン上限による分割をクリーンに処理します。網羅的で省略のない出力が必要なあらゆるタスクに適用してください。',
    examplePrompt:
      '要求された成果物の完全な実装を生成します。プレースホルダーのコメントや省略されたセクションは一切なく、出力長が必要とする場合にのみクリーンな分割指示を含めます。',
  },
  'paywall-upgrade-cro': {
    description:
      'アップグレード画面、ペイウォール、アップセルモーダルを設計・最適化します。SaaSのコンバージョン設計や料金ページの実験に役立ちます。',
    examplePrompt:
      'アップグレード画面、ペイウォール、アップセルモーダルを設計・最適化します。',
  },
  'pdf': {
    description:
      'テキストの抽出、PDFの作成、フォームの処理を行います。プレスリリース、ブランド化された1枚資料、印刷可能なデザイン成果物に役立ちます。',
    examplePrompt:
      'テキストの抽出、PDFの作成、フォームの処理を行います。',
  },
  'pixelbin-media': {
    description:
      '85種類以上のAPIポートフォリオで画像と動画を生成・編集し、Pixelbinを通じて視覚的に魅力的なウェブサイトページを構築します。',
    examplePrompt:
      '85種類以上のAPIポートフォリオで画像と動画を生成・編集し、Pixelbinを通じて視覚的に魅力的なウェブサイトページを構築します。',
  },
  'plan-design-review': {
    description:
      'シニアデザイナーによるレビュー：各デザイン項目を0～10で評価し、10点とはどのようなものかを説明し、AI Slopの兆候を指摘します。UI作業をマージする前のゲートとして役立ちます。',
    examplePrompt:
      'シニアデザイナーによるレビュー：各デザイン項目を0～10で評価し、10点とはどのようなものかを説明し、AI Slopの兆候を指摘します。',
  },
  'platform-design': {
    description:
      'クロスプラットフォームアプリ向けに、Apple HIG、Material Design 3、WCAG 2.2による300以上のデザインルールを提供します。iOS、Android、ウェブにまたがる単一のデザインを出荷する際に役立ちます。',
    examplePrompt:
      'クロスプラットフォームアプリ向けに、Apple HIG、Material Design 3、WCAG 2.2による300以上のデザインルールを提供します。',
  },
  'poster-hero': {
    description:
      '強い視覚的インパクトを持つ縦型ポスターまたはモーメンツ風シェア画像。',
    examplePrompt:
      'マーケティングポスターのテンプレートを使って、私のコンテンツを強い視覚的インパクトを持つ縦型ポスターまたはモーメンツ風シェア画像に変換してください。テンプレートのビジュアルの特徴を保ち、実際のコンテンツとデータを使用し、ダミーテキストやプレースホルダー画像は避けてください。',
  },
  'ppt-keynote': {
    description:
      'Apple Keynote品質のスライド。1画面に1カード、キーボードの左右でナビゲーション可能。',
    examplePrompt:
      'Keynote風スライドのテンプレートを使って、私のコンテンツを1画面に1カードでキーボードの左右ナビゲーションが可能なApple Keynote品質のスライドに変換してください。テンプレートのビジュアルの特徴を保ち、実際のコンテンツとデータを使用し、ダミーテキストやプレースホルダー画像は避けてください。',
  },
  'pptx': {
    description:
      'PowerPointのスライド、レイアウト、テンプレートを読み込み、生成、調整します。役員向けデッキ、研修資料、製品レビューに役立ちます。',
    examplePrompt:
      'PowerPointのスライド、レイアウト、テンプレートを読み込み、生成、調整します。',
  },
  'pptx-generator': {
    description:
      'PptxGenJSを使ってPowerPointプレゼンテーションをゼロから作成・編集します。MiniMaxの実運用で検証されたデッキパイプラインです。',
    examplePrompt:
      'PptxGenJSを使ってPowerPointプレゼンテーションをゼロから作成・編集します。MiniMaxの実運用で検証されたデッキパイプラインです。',
  },
  'pptx-html-fidelity-audit': {
    description:
      'python-pptxのエクスポートを元のHTMLデッキと照合して監査し、レイアウトやコンテンツのずれ（フッターのあふれ、切り取られたコンテンツ、欠落した斜体/強調、失われたスタイリング、リズムを崩した余白）を特定し、厳格なフッターレール＋カーソルフローのレイアウト規律で再エクスポートします。ユーザーがHTMLスライドデッキから生成された.pptxを持っていて、エクスポートの比較/監査/検証/修正を求めるときに、このスキルを使用してください。「ppt と html を比較」「忠実度監査」「pptx を修正」「ppt が切れている」「フッターの重なり」「pptx で斜体が欠落」「デッキを再エクスポート」「pptx-html-fidelity-audit」といった表現や、python-pptx → HTML のラウンドトリップの検証や修復が必要なあらゆるケースを含みます。ユーザーが deck.html と deck.pptx を並べて表示し、視覚的な差異をデバッグしているときにも起動してください。',
    examplePrompt:
      'python-pptxのエクスポートを元のHTMLデッキと照合して監査し、レイアウトやコンテンツのずれ（フッターのあふれ、切り取られたコンテンツ、欠落した斜体/強調、失われたスタイリング、リズムを崩した余白）を特定し、厳格なフッターレール＋カーソルフローのレイアウト規律で再エクスポートします。',
  },
  'pr-feedback-quality-gate': {
    description:
      'プルリクエストのフィードバックを安全に追跡し、レビューコメントやマージコンフリクトを解決し、修正を検証し、フォローアップの変更をコミットまたはプッシュする前に読み取り専用のクロスレビューを活用します。',
    examplePrompt:
      'プルリクエストのフィードバックを安全に追跡し、レビューコメントやマージコンフリクトを解決し、修正を検証し、フォローアップの変更をコミットまたはプッシュする前に読み取り専用のクロスレビューを活用します。',
  },
  'redesign-existing-projects': {
    description:
      '既存のウェブサイトやアプリをプレミアム品質にアップグレードします。現在のデザインを監査し、ありがちなAIパターンを特定し、機能を損なうことなくハイエンドなデザイン基準を適用します。あらゆるCSSフレームワークや素のCSSに対応します。',
    examplePrompt:
      'まず既存のUIを監査し、その後、有用なプロダクト構造を保ちつつ、機能を損なうことなくプレミアム品質に再設計してください。',
  },
  'reference-design-contract': {
    description:
      '曖昧な好み、スクリーンショット、URL、製品メモ、あるいは「こんな感じにしてほしい」という\nリファレンスを、根拠のあるDESIGN.mdと実装への引き継ぎ資料に変換します。プロトタイプ、デッキ、\n再デザイン、画像リミックス作業の前に、ユーザーが単発のプロンプトではなく再利用可能なビジュアルの\n方向性を必要とするときに使用してください。',
    examplePrompt:
      '開発者向けノートアプリのためのリファレンスデザイン契約を作成してください。方向性は、編集的で、落ち着いていて、触感があり、真面目な印象であるべきですが、特定の製品をそのまま模倣しないでください。DESIGN.mdと実装への引き継ぎ資料を作成してください。',
  },
  'release-notes-one-pager': {
    description:
      'ハイライト、追加、修正、破壊的変更、\n既知の問題、アップグレード注記を含むリリースノートの1ページHTML。ユーザーが詳細を提供しない場合は\nいつでも明示的に「なし」スタイルのセクションを記述します。',
    examplePrompt:
      'v2.3.1のリリースノートを、追加、修正、破壊的変更、既知の問題、アップグレード注記とともに書いてください。',
  },
  'remotion': {
    description:
      'Reactによるプログラム的な動画作成。ブランド化された解説動画、ソーシャル向けカット、ダッシュボードの動画化、再現可能なモーショングラフィックスに役立ちます。',
    examplePrompt:
      'Reactによるプログラム的な動画作成。',
  },
  'replicate': {
    description:
      'ReplicateのAPIを使ってAIモデルを発見、比較、実行します。モデルを頻繁に切り替える画像、音声、動画の生成パイプラインに最適です。',
    examplePrompt:
      'ReplicateのAPIを使ってAIモデルを発見、比較、実行します。',
  },
  'research-decision-room': {
    description:
      '雑然としたユーザーリサーチのメモ、インタビュー、サポートチケット、アンケート、製品の\nコンテキストを、証拠に裏付けられた意思決定ルームに変換します。証拠台帳、\nテーママップ、信頼度ヒートマップ、機会マトリクス、意思決定メモ、実験キューを備えた単一のHTML成果物です。\nチームが確実性を捏造することなく、定性的なシグナルから製品やデザインの意思決定へと\n進む必要があるときに使用してください。',
    examplePrompt:
      '8件のインタビューメモ、24件のサポートチケット、最近のアクティベーション指標を統合し、プロジェクト管理アプリがオンボーディングのチェックリストを追加すべきか、それとも文脈に応じたインラインのヒントを追加すべきかについてのリサーチ意思決定ルームを作成してください。',
  },
  'resume-modern': {
    description:
      'モダンでミニマルな履歴書。A4一枚で、印刷またはPDFエクスポートに対応。',
    examplePrompt:
      'モダン履歴書のテンプレートを使って、私のコンテンツを印刷またはPDFエクスポートに対応したモダンでミニマルなA4一枚の履歴書に変換してください。テンプレートのビジュアルの特徴を保ち、実際のコンテンツとデータを使用し、ダミーテキストやプレースホルダー画像は避けてください。',
  },
  'screenshot': {
    description:
      '各OSプラットフォームでデスクトップ、アプリのウィンドウ、ピクセル領域をキャプチャします。マーケティング用スクリーンショット、デザインレビュー、バグレポートに役立ちます。',
    examplePrompt:
      '各OSプラットフォームでデスクトップ、アプリのウィンドウ、ピクセル領域をキャプチャします。',
  },
  'screenshots-marketing': {
    description:
      'Playwright でマーケティング用スクリーンショットを生成します。ランディングページのヒーロー画像、App Store のスクリーンショット、変更履歴のビジュアルに便利です。',
    examplePrompt:
      'Playwright でマーケティング用スクリーンショットを生成します。',
  },
  'shadcn-ui': {
    description:
      'shadcn/ui で UI コンポーネントを構築します。Stitch のデザインループと組み合わせて、構造化されたアクセシブルなコンポーネントを素早く出荷できます。',
    examplePrompt:
      'shadcn/ui で UI コンポーネントを構築します。',
  },
  'shader-dev': {
    description:
      'レイマーチング、流体シミュレーション、パーティクルシステム、プロシージャル生成のための GLSL シェーダー技術。ヒーロービジュアルやモーションスチルに便利です。',
    examplePrompt:
      'レイマーチング、流体シミュレーション、パーティクルシステム、プロシージャル生成のための GLSL シェーダー技術。',
  },
  'slack-gif-creator': {
    description:
      'Slack 向けに最適化されたアニメーション GIF を作成します。サイズ制約のバリデーターと組み合わせ可能なアニメーションプリミティブを備えています。',
    examplePrompt:
      'Slack 向けに最適化されたアニメーション GIF を作成します。サイズ制約のバリデーターと組み合わせ可能なアニメーションプリミティブを備えています。',
  },
  'slides': {
    description:
      'PptxGenJS で .pptx プレゼンテーション資料を作成・編集します。営業資料、キックオフ用ブリーフ、デザインシステムのショーケースに便利です。',
    examplePrompt:
      'PptxGenJS で .pptx プレゼンテーション資料を作成・編集します。',
  },
  'social-reddit-card': {
    description:
      '投票バーとコメント数を備えたリアルな Reddit 投稿カード。動画オーバーレイやストーリー共有に適しています。',
    examplePrompt:
      'Reddit Post Card テンプレートを使って、私のコンテンツを投票バーとコメント数付きのリアルな Reddit 投稿カードに変換し、動画オーバーレイやストーリー共有に使えるようにしてください。テンプレートのビジュアルシグネチャーを維持し、実際のコンテンツとデータを使用し、ロレムイプサムやプレースホルダー画像は避けてください。',
  },
  'social-spotify-card': {
    description:
      'アルバムアート、プログレスバー、再生コントロールを備えた Spotify Now Playing 風のカード。動画オーバーレイや個人ホームページに適しています。',
    examplePrompt:
      'Spotify Now-Playing Card テンプレートを使って、私のコンテンツをアルバムアート、プログレスバー、再生コントロール付きの Spotify Now Playing 風カードに変換し、動画オーバーレイや個人ホームページに使えるようにしてください。テンプレートのビジュアルシグネチャーを維持し、実際のコンテンツとデータを使用し、ロレムイプサムやプレースホルダー画像は避けてください。',
  },
  'social-x-post-card': {
    description:
      'エンゲージメント指標（いいね、リポスト、表示回数）を備えたリアルな X 投稿カード。動画オーバーレイや共有可能な画像カードに適しています。',
    examplePrompt:
      'X / Twitter Post Card テンプレートを使って、私のコンテンツをエンゲージメント指標付きのリアルな X 投稿カードに変換し、動画オーバーレイや共有可能な画像カードに使えるようにしてください。テンプレートのビジュアルシグネチャーを維持し、実際のコンテンツとデータを使用し、ロレムイプサムやプレースホルダー画像は避けてください。',
  },
  'high-end-visual-design': {
    description:
      'ハイエンドなエージェンシーのようにデザインする方法を AI に教えます。ウェブサイトを高級に見せるフォント、余白、シャドウ、カード構造、アニメーションを正確に定義します。AI デザインを安っぽく一般的に見せてしまう一般的なデフォルトをすべてブロックします。',
    examplePrompt:
      '洗練されたタイポグラフィ、柔らかいコントラスト、上質な余白、繊細な奥行き、抑制されたモーションを備えた、落ち着いたハイエンドなランディングページを作成してください。',
  },
  'sora': {
    description:
      'OpenAI の Sora API を介してショート動画クリップを生成、リミックス、管理します。シネマティックなショット、B ロール、迅速なコンセプト動画のイテレーションに便利です。',
    examplePrompt:
      'OpenAI の Sora API を介してショート動画クリップを生成、リミックス、管理します。',
  },
  'speech': {
    description:
      'OpenAI の API と組み込み音声を使って、テキストから音声を生成します。ナレーション付き解説、講義音声、迅速なボイスオーバートラックに便利です。',
    examplePrompt:
      'OpenAI の API と組み込み音声を使って、テキストから音声を生成します。',
  },
  'stitch-loop': {
    description:
      '反復的なデザインからコードへのフィードバックループ。ブリーフと構築済み UI の間でビジュアル忠実度を高めるための、批評 → 調整 → 出荷のサイクルです。',
    examplePrompt:
      '反復的なデザインからコードへのフィードバックループ。',
  },
  'stitch-design-taste': {
    description:
      'Google Stitch 用のセマンティックデザインシステム Skill。上質で一般的でない UI 基準を強制する、エージェントフレンドリーな DESIGN.md ファイルを生成します。厳格なタイポグラフィ、調整されたカラー、非対称レイアウト、絶え間ないマイクロモーション、ハードウェアアクセラレーションによるパフォーマンスを実現します。',
    examplePrompt:
      'この製品向けに、上質で一般的でない UI 基準、タイポグラフィ、カラー、レイアウト、モーション、プロンプトガイダンスを備えた、エージェントフレンドリーな DESIGN.md を生成してください。',
  },
  'swiftui-design': {
    description:
      'SwiftUI フロントエンドデザイン skill — AI スロップ防止ルール、デザイン方針アドバイザー、ブランドアセットプロトコル、5 次元レビュー。Claude Code、Cursor、Codex、OpenCode で動作します。',
    examplePrompt:
      'SwiftUI フロントエンドデザイン skill — AI スロップ防止ルール、デザイン方針アドバイザー、ブランドアセットプロトコル、5 次元レビュー。',
  },
  'swiss-creative-mode-template': {
    description:
      'スイススタイルにインスパイアされたクリエイティブモードのプレゼンテーションテンプレート skill。大胆なエディトリアルタイポグラフィ、\nハイコントラストな幾何学カード、インタラクティブなスライドナビゲーション、\nテーマ切り替え、ホットスポットオーバーレイ、パレットの振り付けを単一ファイルの\nHTML アーティファクトに収めています。プレミアムなプレゼンテーション風ランディング、\nスイス/ブルータリスト風の資料の見た目、リッチなインタラクションを備えたクリエイティブな\nローンチページをユーザーが求めるときに使用してください。',
    examplePrompt:
      'スイススタイルにインスパイアされたクリエイティブモードのプレゼンテーションテンプレート skill。大胆なエディトリアルタイポグラフィ、ハイコントラストな幾何学カード、インタラクティブなスライドナビゲーション、テーマ切り替え、ホットスポットオーバーレイ、パレットの振り付けを単一ファイルの HTML アーティファクトに収めています。',
  },
  'swiss-user-research-video-template': {
    description:
      '温かみのある紙のようなエディトリアル美学を持つスイススタイルのユーザーリサーチ・ナラティブテンプレート。\nミニマリストなタイポグラフィ、高い視認性のレイアウト、繊細なモーション、ドーナツチャートによる内訳、\n単一の HTML ファイル内でのスライド間のキーボード/クリックナビゲーションを備えた、\nプレミアムなリサーチ資料やストーリー優先のライブアーティファクトをユーザーが求めるときに使用してください。',
    examplePrompt:
      'プレミアムでミニマリストなタイポグラフィ、温かみのある紙のトーン、参加者のドーナツチャートによる内訳、繊細なエディトリアルインタラクションを備えた、スイススタイルのユーザーリサーチ統合資料を作成してください。',
  },
  'design-taste-frontend': {
    description:
      'ランディングページ、ポートフォリオ、リデザインのためのスロップ防止フロントエンド skill。エージェントがブリーフを読み、適切なデザイン方針を推測し、テンプレートのように見えないインターフェースを出荷します。必要に応じて実際のデザインシステムを使用し、リデザインでは監査優先、厳格なプリフライトチェックを行います。',
    examplePrompt:
      'design-taste-frontend に従ったプレミアムなランディングページを作成してください。デザインの読み取りを推測し、ダイヤルを設定し、AI スロップのパターンを避け、洗練されたレスポンシブな HTML アーティファクトを出力してください。',
  },
  'design-taste-frontend-v1': {
    description:
      'オリジナルの v1 テイスト skill。その正確な挙動に依存するプロジェクトのために保存されています。現在のデフォルトは `design-taste-frontend`（v2 実験版）で、大幅に書き直されています。正確な後方互換性が必要な場合のみ、この v1 のインストール名を使用してください。',
    examplePrompt:
      'design-taste-frontend-v1 を使って、力強いタイポグラフィ、余白、モーション、スロップ防止のガードレールを備えた、洗練されたマーケティングページを作成してください。',
  },
  'theme-factory': {
    description:
      'スライド、ドキュメント、レポート、HTML ランディングページなどのアーティファクトに、プロフェッショナルなフォントとカラーのテーマを適用します。10 種類のプリセットテーマを備えています。',
    examplePrompt:
      'スライド、ドキュメント、レポート、HTML ランディングページなどのアーティファクトに、プロフェッショナルなフォントとカラーのテーマを適用します。',
  },
  'threejs': {
    description:
      'ブラウザ上で 3D 要素やインタラクティブな体験を作成するための Three.js skill — シーン、マテリアル、コントロール、ポストプロセッシング。',
    examplePrompt:
      'ブラウザ上で 3D 要素やインタラクティブな体験を作成するための Three.js skill — シーン、マテリアル、コントロール、ポストプロセッシング。',
  },
  'ui-skills': {
    description:
      'インターフェース構築時にエージェントを導くための、独自の見解を持つ進化的な制約。多数の小さな UI パーツ全体で出力の一貫性を保つのに役立ちます。',
    examplePrompt:
      'インターフェース構築時にエージェントを導くための、独自の見解を持つ進化的な制約。',
  },
  'ui-ux-pro-max': {
    description:
      'カタログのみの UI/UX Pro Max エントリー。完全なアップストリームのテンプレート、データ、検索ワークフローは Open Design には同梱されていません。',
    examplePrompt:
      'カタログのみの UI/UX Pro Max エントリー。',
  },
  'venice-audio-music': {
    description:
      'Venice.ai 経由の音楽生成のキューイング、取得、完了エンドポイント。ジングル、バックグラウンドループ、プロトタイプの劇伴に適しています。',
    examplePrompt:
      'Venice.ai 経由の音楽生成のキューイング、取得、完了エンドポイント。',
  },
  'venice-audio-speech': {
    description:
      'Venice.ai 経由のテキスト読み上げモデル、音声、フォーマット、ストリーミング。ナレーション、ボイスオーバー、対話型エージェントの音声に役立ちます。',
    examplePrompt:
      'Venice.ai 経由のテキスト読み上げモデル、音声、フォーマット、ストリーミング。',
  },
  'venice-image-edit': {
    description:
      'Venice.ai API による画像編集、アップスケーリング、背景除去。',
    examplePrompt:
      'Venice.ai API による画像編集、アップスケーリング、背景除去。',
  },
  'venice-image-generate': {
    description:
      'Venice.ai API による画像生成エンドポイントと利用可能なスタイル。',
    examplePrompt:
      'Venice.ai API による画像生成エンドポイントと利用可能なスタイル。',
  },
  'venice-video': {
    description:
      'Venice.ai API による動画生成と文字起こしのワークフロー。',
    examplePrompt:
      'Venice.ai API による動画生成と文字起こしのワークフロー。',
  },
  'vfx-text-cursor': {
    description:
      '動画のイントロで単語ごとに表示される引用の演出向けの、カーソルライトトレイル、色収差レイ、方向性のあるフレア。',
    examplePrompt:
      'VFX Text Cursor テンプレートを使って、私のコンテンツを、カーソルライトトレイル、色収差レイ、方向性のあるフレアを備えた動画イントロの引用演出に変換してください。テンプレートのビジュアルの特徴を保持し、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像は使わないでください。',
  },
  'video-downloader': {
    description:
      'YouTube やその他のプラットフォームから動画をダウンロードし、オフライン視聴、編集、アーカイブに利用できます。さまざまなフォーマットと品質オプションに対応。',
    examplePrompt:
      'YouTube やその他のプラットフォームから動画をダウンロードし、オフライン視聴、編集、アーカイブに利用できます。さまざまなフォーマットと品質オプションに対応。',
  },
  'video-hyperframes': {
    description:
      '自動再生対応の Hyperframes / Remotion 互換の連続フレームアニメーション。',
    examplePrompt:
      'Hyperframes Video テンプレートを使って、私のコンテンツを、自動再生対応の Hyperframes / Remotion 互換の連続フレームアニメーションに変換してください。テンプレートのビジュアルの特徴を保持し、実際のコンテンツとデータを使用し、lorem ipsum やプレースホルダー画像は使わないでください。',
  },
  'web-artifacts-builder': {
    description:
      'React と Tailwind を使って複雑な claude.ai の HTML アーティファクトを構築します。リッチで埋め込み可能なアーティファクトを公開するための Anthropic のリファレンスワークフローです。',
    examplePrompt:
      'React と Tailwind を使って複雑な claude.ai の HTML アーティファクトを構築します。',
  },
  'web-design-guidelines': {
    description:
      'Vercel エンジニアリングチームによる Web デザインのガイドラインと標準。プロダクト UI のレイアウト、タイポグラフィ、カラー、モーション、アクセシビリティを網羅します。',
    examplePrompt:
      'Vercel エンジニアリングチームによる Web デザインのガイドラインと標準。',
  },
  'weread-year-in-review-video-template': {
    description:
      'WeRead にインスパイアされた HyperFrames 動画テンプレート。縦型の年間読書レポート、\n個人の読書ダッシュボード、読書メモのまとめ、共有可能な年間振り返り\nストーリー向けです。温かみのある紙の質感、エディトリアルな中国語タイポグラフィ、\n本のページのメタファー、データのハイライト、決定論的なモーションを備えた\n9:16 の HTML-to-MP4 読書レポートが必要なときに使用してください。',
    examplePrompt:
      'WeRead スタイルの 9:16 HyperFrames 年間読書レポート動画を作成します。12 のシーン、温かみのある紙の質感、本のページの遷移、読書統計、メモ、キーワード、そして最後に読書ペルソナカードを含みます。',
  },
  'wpds': {
    description:
      'WordPress デザインシステム。WordPress 公式のデザイントークン、タイポグラフィ、コンポーネントパターンをテーマやサイトに適用します。',
    examplePrompt:
      'WordPress デザインシステム。',
  },
  'youtube-clipper': {
    description:
      '自動化ワークフローによる YouTube クリップの生成と編集 — ソース動画を取得し、ハイライトを切り出し、字幕を追加してエクスポートします。',
    examplePrompt:
      '自動化ワークフローによる YouTube クリップの生成と編集 — ソース動画を取得し、ハイライトを切り出し、字幕を追加してエクスポートします。',
  },
};

export const JA_DESIGN_SYSTEM_SUMMARIES: Record<string, string> = {
  'agentic': '最小限のコントロール、明確な成果、委任されたタスクフローを備えた、対話型 AI ファーストのインターフェース。エージェント型ワークフロー向けです。',
  'airbnb': '旅行マーケットプレイス。温かみのあるコーラルのアクセント、写真主導、丸みのある UI。',
  'airtable': 'スプレッドシートとデータベースのハイブリッド。カラフルで親しみやすく、構造化されたデータの美学。',
  'ant': '明快さ、一貫性、効率性を重視した、構造化されたエンタープライズ向けデザインシステム。データ密度の高い Web アプリケーション向けです。',
  'apple': '家電。上質な余白、SF Pro、シネマティックなイメージ。',
  'application': 'パープルを基調とした美学、トップバーナビゲーション、カードベースのレイアウト、開発者ファーストのワークフローを備えたアプリダッシュボード。',
  'arc': '「あなたの代わりにブラウズするブラウザ。」半透明のサーフェス、グラデーションの温かみ、サイドバーファーストのレイアウト。',
  'artistic': '視覚的に印象的なインターフェースのための、クリエイティブなタイポグラフィと大胆な配色を備えた、高コントラストで表現力豊かなスタイル。',
  'atelier-zero': 'マガジン品質でコラージュ主導のビジュアルシステム。温かみのある紙のキャンバス、\nシュールな石膏と建築のイメージ、特大のディスプレイ書体、極細の罫線、\nローマ数字のセクションマーカー、そして小さなエディトリアルな注釈。\nプロダクション版にインスパイアされています。',
  'bento': 'カード状のブロックによるモジュラーグリッドレイアウト。明確な階層、柔らかなスペーシング、繊細な視覚的コントラストで、整理されてスキャンしやすいインターフェースを実現します。',
  'binance': '暗号資産取引所。モノクロに大胆なイエローのアクセント、取引フロアの緊迫感。',
  'bmw': '高級自動車。ダークでプレミアムな質感、精緻なドイツエンジニアリングの美学。',
  'bmw-m': 'モータースポーツのパフォーマンス系サブブランド。ほぼ漆黒のコックピット質感、BMW Mのトリコロールアクセント、シャープなエンジニアリング・ジオメトリ。',
  'bold': '重厚なタイポグラフィ、ハイコントラストな配色、堂々としたレイアウトによる強烈なビジュアルの存在感。',
  'brutalism': 'コンクリート建築に着想を得た、生々しいアンチデザインの美学。装飾を排した要素、不協和なレイアウト、機能的なミニマリズム。',
  'bugatti': 'ハイパーカーブランド。シネマブラックのキャンバス、モノクロの簡潔さ、記念碑的なディスプレイタイプ。',
  'cafe': '居心地のよいカフェに着想を得たインターフェース。温かみのある色調、柔らかなタイポグラフィ、リラックスして閲覧できるクリーンなレイアウト。',
  'cal': 'オープンソースのスケジューリング。クリーンでニュートラルなUI、開発者向けのシンプルさ。',
  'canva': 'ビジュアル制作プラットフォーム。鮮やかなパープルブルーのグラデーション、ゆったりとした余白、親しみやすいジオメトリ。',
  'cisco': 'エンタープライズ向けインフラブランド。信頼感のあるダークな質感、Cisco Blueのシグナル、技術的な明快さ。',
  'claude': 'AnthropicのAIアシスタント。温かみのあるテラコッタのアクセント、クリーンなエディトリアルレイアウト。',
  'clay': 'クリエイティブエージェンシー。有機的なシェイプ、柔らかなグラデーション、アートディレクションされたレイアウト。',
  'claymorphism': '自在に形を変える粘土を思わせる、柔らかく丸みを帯びた3D風のシェイプ。遊び心のあるふっくらとした要素とカラフルな質感。',
  'clean': 'シンプルさを重視したデザイン。たっぷりの余白、読みやすいタイポグラフィ、視覚的なごちゃつきを抑える限定的なカラーパレット。',
  'clickhouse': '高速な分析データベース。イエローのアクセント、技術ドキュメント風のスタイル。',
  'cohere': 'エンタープライズ向けAIプラットフォーム。鮮やかなグラデーション、データ豊富なダッシュボードの美学。',
  'coinbase': '暗号資産取引所。クリーンなブルーのアイデンティティ、信頼感を重視した、機関投資家らしい雰囲気。',
  'colorful': '鮮やかでハイコントラストなパレットとグラデーションによる、魅力的で記憶に残るモダンなユーザー体験。',
  'composio': 'ツール連携プラットフォーム。モダンなダークに、カラフルな連携アイコン。',
  'contemporary': 'ベントグリッド、ダークモード対応、高パフォーマンスでアクセシブルなレイアウトを備えた、現代的なミニマリストデザイン。',
  'corporate': '構造化されたグリッド、ミニマルなレイアウト、一貫したエンタープライズパターンによる、プロフェッショナルでブランドに沿ったデザイン。',
  'cosmic': 'ダークテーマ、鮮やかなネオンのアクセント、没入感のある空間的要素による未来的なSFの美学。',
  'creative': '表情豊かなタイポグラフィと大胆なグラフィックを用いた、遊び心とキャラクター性のあるデザイン。ランディングページやクリエイティブプロジェクトに。',
  'cursor': 'AIファーストのコードエディタ。洗練されたダークインターフェース、グラデーションのアクセント。',
  'dashboard': 'モジュラーグリッド、ガラスのようなパネル、強いデータ階層を備えた、生産性ダッシュボード向けのダークテーマなクラウドプラットフォームの美学。',
  'default': 'B2Bツール、ダッシュボード、ユーティリティページ向けの、クリーンでプロダクト志向のデフォルト。',
  'discord': 'ボイス／チャットプラットフォーム。深いブラープル、ダーク基調の質感、遊び心のあるアクセント。',
  'dithered': '限定的なパレットで陰影を表現するドットパターンの描画手法。ノスタルジックでレトロ、ハイコントラストなビジュアルに。',
  'doodle': '落書き、手書きフォント、不揃いな線による、手描き・スケッチ風のスタイル。遊び心のあるカジュアルな雰囲気に。',
  'dramatic': '大胆なレイアウト、没入感のあるビジュアル、型破りな構成で視線を引きつける、ハイコントラストで演劇的なデザイン。',
  'duolingo': '語学学習プラットフォーム。明るいフクロウのグリーン、ぼってりとしたシャドウ、ゲーミフィケーションの楽しさ。',
  'editorial': '洗練されたセリフ体タイポグラフィ、構造化されたグリッド、上質な読書体験による、マガジン風のエディトリアルレイアウト。',
  'elegant': '繊細なタイポグラフィ、ミニマルなパレット、洗練されたレイアウトで気品を醸し出す、優雅で洗練された美学。',
  'elevenlabs': 'AIボイスプラットフォーム。ダークでシネマティックなUI、オーディオ波形の美学。',
  'energetic': '太いボーダー、幾何学的なシェイプ、ハイコントラストな配色、表情豊かなタイポグラフィで躍動感と生命力を伝える、ダイナミックで鮮やかなスタイル。',
  'enterprise': '直感的なドラッグ＆ドロップのパターンと構造化されたレイアウトを備えた、データ駆動型ワークフロー向けのクリーンでハイコントラストなエンタープライズデザイン。',
  'expo': 'React Nativeプラットフォーム。ダークテーマ、詰めた字間、コード中心。',
  'expressive': '大胆な色使い、遊び心のあるグラフィック、ダイナミックなレイアウトで創造性と構造性を両立させる、鮮やかで個性豊かなデザイン。',
  'fantasy': '大胆でプレミアムなビジュアル、豊かなカラーパレット、没入感のあるテーマ要素による、ゲーム風のファンタジー美学。',
  'ferrari': '高級自動車。キアロスクーロのエディトリアル、Ferrari Redのアクセント、シネマティックなブラック。',
  'figma': 'コラボレーション型デザインツール。鮮やかなマルチカラーで、遊び心がありながらプロフェッショナル。',
  'flat': '鮮やかな色彩、すっきりとしたタイポグラフィ、3D効果のない二次元的なミニマリストスタイルで、高速かつユーザーフレンドリーなインターフェースを実現。',
  'framer': 'ウェブサイトビルダー。大胆なブラックとブルー、モーション重視、デザイン先進型。',
  'friendly': '丸みのある要素、十分な余白、柔らかなパステルカラーパレットを用いた、親しみやすく直感的なデザイン。',
  'futuristic': 'テック感のあるタイポグラフィ、モダンなレイアウト、洗練されたイノベーション主導の美学を備えた未来志向のデザイン。',
  'github': 'コード重視のプラットフォーム。機能的な高密度、ホワイト上のブルーによる精緻さ、Primerを基盤とした設計。',
  'glassmorphism': '半透明のレイヤー、繊細なぼかし、光を放つボーダーによるすりガラス効果で、奥行きとモダンな上品さを表現。',
  'gradient': 'なめらかな色の遷移とグラデーション豊かな面で、視覚的な奥行きのあるモダンで遊び心のあるインターフェースを実現。',
  'hashicorp': 'インフラ自動化。エンタープライズらしいクリーンな、ブラックとホワイト。',
  'hud': '戦闘機/ヘリコプターのヘッドアップディスプレイ。ほぼ漆黒の背景に蛍光グリーン、全大文字のデータオーバーレイ、角張ったジオメトリ。高速・高高度でも曖昧さゼロ。',
  'huggingface': 'MLコミュニティハブ。明るいイエローのアクセント、等幅フォントのアイデンティティ、陽気で高密度。',
  'ibm': 'エンタープライズテクノロジー。Carbonデザインシステム、構造化されたブルーパレット。',
  'intercom': 'カスタマーメッセージング。親しみやすいブルーパレット、会話型UIパターン。',
  'kami': 'エディトリアルな紙のシステム：温かみのある羊皮紙調のキャンバス、インクブルーのアクセント、セリフ主導の階層構造。履歴書、ワンページャー、ホワイトペーパー、ポートフォリオ、スライドデッキなど、UIというより高品質な印刷物のように感じられるべきものすべてのために設計。デフォルトで多言語対応',
  'kraken': '暗号資産トレーディング。パープルをアクセントにしたダークUI、データ密度の高いダッシュボード。',
  'lamborghini': 'スーパーカーブランド。真の黒い面、ゴールドのアクセント、ドラマチックな大文字タイポグラフィ。',
  'levels': '摩擦を取り除き、明快さ・信頼・スピードによってユーザーを行動へと導く、コンバージョン重視のデザイン。',
  'linear-app': 'プロジェクト管理。極限までミニマルで精緻、パープルのアクセント。',
  'lingo': '明るい色彩、丸みのある形状、触感のある3Dボーダー、親しみやすいイラストを用いた、遊び心のあるミニマルなデザインで、とっつきやすいインターフェースを実現。',
  'loom': 'Loomの非同期ビデオ。パープルをメインに、親しみやすい面、ビデオ重視のレイアウト。お堅くなりすぎない、クリーンでプロフェッショナルな印象。',
  'lovable': 'AIフルスタックビルダー。遊び心のあるグラデーション、親しみやすい開発者向けの美学。',
  'luxury': '大胆な見出し、モノクロパレット、プレミアムな質感を備えたハイエンドなダークの美学で、ラグジュアリーブランド体験を実現。',
  'mastercard': 'グローバル決済ネットワーク。温かみのあるクリーム色のキャンバス、軌道を描くピル形状、エディトリアルな温かみ。',
  'material': 'レイヤー化された面、ダイナミックなテーマ設定、組み込みのモーション、レスポンシブなクロスプラットフォームパターンを備えたGoogleのMaterial Design。',
  'meta': 'テック系小売店。写真重視、ライト/ダークの二極の面、Meta BlueのCTA。',
  'minimal': '余白、クリーンなタイポグラフィ、抑えた色使いを重視し、最大限の明快さと集中を実現する、削ぎ落としたデザイン。',
  'minimax': 'AIモデルプロバイダー。ネオンのアクセントを効かせた大胆なダークインターフェース。',
  'mintlify': 'ドキュメンテーションプラットフォーム。クリーンでグリーンをアクセントにした、読みやすさに最適化されたデザイン。',
  'miro': 'ビジュアルコラボレーション。明るいイエローのアクセント、無限キャンバスの美学。',
  'mission-control': '宇宙/航空宇宙のミッション監視。ダークなコマンドセンター、アンバーのテレメトリ、等幅フォントの精緻さ。何よりも機能的な明快さを重視。',
  'mistral-ai': 'オープンウェイトのLLMプロバイダー。フランス流に設計されたミニマリズム、パープル基調。',
  'modern': 'セリフ体のタイポグラフィ、ミニマルなパレット、クリーンなレイアウトを備えた現代的なエディトリアルスタイルで、洗練されたデジタルプロダクトを実現。',
  'mongodb': 'ドキュメントデータベース。緑の葉のブランディング、開発者向けドキュメントに重点。',
  'mono': '等幅フォント主導でマトリックスにインスパイアされたデザイン。高コントラストな要素、コンパクトな密度、ハッカーシックな美学。',
  'neobrutalism': '大胆なボーダー、鮮やかなアクセントカラー、温かみのある面の上に展開する生々しく高コントラストなレイアウトを備えた、ブルータリズムの現代的解釈。',
  'neon': '高コントラストな配色によるエレクトリックなネオンの輝き効果で、大胆で目を引くインターフェースを実現。',
  'neumorphism': 'モノクロの面に内側と外側のシャドウを施した、柔らかく押し出されたUI要素で、触感のある埋め込み風のルックを表現。',
  'nike': 'アスレチック系小売。モノクロUI、巨大な大文字タイプ、全面写真。',
  'notion': 'オールインワンのワークスペース。温かみのあるミニマリズム、セリフ体の見出し、柔らかな面。',
  'nvidia': 'GPUコンピューティング。グリーンとブラックのエネルギー、テクニカルなパワーの美学。',
  'ollama': 'LLM をローカルで実行。ターミナル優先、モノクロのシンプルさ。',
  'openai': '深いティールブラックを基調とした、落ち着いたほぼモノクロのシステム。ゆとりある余白とエディトリアルなタイポグラフィが特徴。',
  'opencode-ai': 'AI コーディングプラットフォーム。開発者中心のダークテーマ。',
  'pacman': 'レトロアーケード風のデザイン。ピクセルフォント、点線のボーダー、遊び心のある高コントラストカラー、8ビットゲームの美学を取り入れています。',
  'paper': '紙の質感を活かした印刷風デザイン。最小限の色使い、クリーンなセリフ／サンセリフのタイポグラフィ、触覚的な表面の質感が特徴。',
  'perplexity': '対話型 AI 検索エンジン。深いダークキャンバス、シャープなタイポグラフィ、単色のバイオレットアクセント、密度の高い情報階層。',
  'perspective': '空間的な奥行きのあるデザイン。アイソメトリックビュー、消失点、レイヤー化された要素を用い、3D のようなリアリズムで視線を誘導します。',
  'pinterest': 'ビジュアルディスカバリー。レッドアクセント、メーソンリーグリッド、画像優先。',
  'playstation': 'ゲーム機の小売。3面チャネルレイアウト、静かな威厳のあるディスプレイ書体、シアンのホバースケール。',
  'posthog': 'プロダクト分析。遊び心のあるハリネズミのブランディング、開発者にやさしいダーク UI。',
  'premium': 'Apple にインスパイアされたプレミアムな美学。緻密な余白設計、モダンなタイポグラフィ、洗練され磨き上げられたビジュアル言語。',
  'professional': '洗練されたビジネス向けデザイン。モダンなタイポグラフィ、構造化されたレイアウト、信頼感のあるビジュアルアイデンティティ。',
  'publication': '書籍、雑誌、レポート向けの印刷風ビジュアル言語。エディトリアルなグリッドと表現力豊かなタイポグラフィを備えています。',
  'raycast': '生産性ランチャー。洗練されたダーククローム、鮮やかなグラデーションアクセント。',
  'refined': '丁寧に厳選されたモダンミニマルスタイル。優雅なセリフタイポグラフィと、控えめで洗練されたパレット。',
  'renault': 'フランスの自動車。鮮やかなオーロラグラデーション、NouvelR タイポグラフィ、大胆なエネルギー。',
  'replicate': 'ML モデルを API 経由で実行。クリーンなホワイトキャンバス、コード重視。',
  'resend': 'メール API。ミニマルなダークテーマ、モノスペースのアクセント。',
  'retro': '懐かしさを感じさせるデザイン。ヴィンテージ風のタイポグラフィ、高コントラストのレトロパレット、ノスタルジックなビジュアル要素。',
  'revolut': 'デジタルバンキング。洗練されたダークインターフェース、グラデーションカード、フィンテックの精密さ。',
  'runwayml': 'AI 動画生成。シネマティックなダーク UI、メディアリッチなレイアウト。',
  'sanity': 'ヘッドレス CMS。レッドアクセント、コンテンツ優先のエディトリアルレイアウト。',
  'sentry': 'エラーモニタリング。ダークなダッシュボード、データ密度が高く、ピンクパープルのアクセント。',
  'shadcn': 'Shadcn/ui にインスパイアされたデザイン。ミニマルでクリーンなコンポーネント、モノクロパレット、ユーティリティファーストのパターン。',
  'shopify': 'E コマースプラットフォーム。ダーク優先のシネマティック、ネオングリーンのアクセント、極細の書体。',
  'simple': '飾り気のないストレートなデザイン。クリーンなタイポグラフィ、ニュートラルな色使い、邪魔をしない直感的なレイアウト。',
  'skeumorphism': '現実世界を模したデザイン。質感のある表面、3D エフェクト、馴染みのある物理的メタファーで、直感的なデジタルインターフェースを実現します。',
  'slack': '職場向けコミュニケーションプラットフォーム。オーベルジーヌ（なす色）を主体に、マルチアクセントのロゴパレット、明るいサーフェスとダークなサイドバーで、温かく親しみやすい印象。',
  'sleek': 'モダンミニマリストの美学。クリーンなライン、意図的なカラーパレット、繊細なインタラクション、一貫した余白。',
  'spacex': '宇宙テクノロジー。鮮明な白黒、フルブリードの画像、未来的。',
  'spacious': 'ゆとりある余白、一貫したパディング、グリッドベースのレイアウトで、クリーンで読みやすく、呼吸するようなインターフェースを実現。',
  'spotify': '音楽ストリーミング。ダークに映える鮮やかなグリーン、大胆な書体、アルバムアート主導。',
  'starbucks': 'グローバルなコーヒー小売ブランド。4階層のグリーンシステム、温かみのあるクリーム色のキャンバス、フルピル型のボタン。',
  'storytelling': '物語性を重視したデザイン。ビジュアル、コピー、インタラクションを用いて、魅力的で感情に響く体験へとユーザーを導きます。',
  'stripe': '決済インフラ。象徴的なパープルのグラデーション、ウェイト300のエレガンス。',
  'supabase': 'オープンソースの Firebase 代替。ダークエメラルドテーマ、コードファースト。',
  'superhuman': '高速なメールクライアント。プレミアムなダーク UI、キーボード優先、パープルのグロー。',
  'tesla': '電気自動車。徹底した引き算、フルビューポートの写真、限りなくゼロに近い UI。',
  'tetris': 'クラシックなブロックゲームにインスパイアされたデザイン。遊び心のある色使い、大胆なディスプレイフォント、コンパクトでエネルギッシュなレイアウト。',
  'theverge': 'テック系エディトリアルメディア。アシッドミントとウルトラバイオレットのアクセント、Manuka ディスプレイ、レイブフライヤー風のストーリータイル。',
  'together-ai': 'オープンソースの AI インフラ。技術的でブループリント風のデザイン。',
  'totality-festival': '皆既日食の本能的な畏怖を捉えた、コズミックでプレミアムなグラスモーフィズムのダークシステム — オブシディアンのサーフェス、琥珀色の「コロナ」ハイライト、シアンの大気的アクセント。',
  'trading-terminal': 'Bloomberg 風の金融トレーディングターミナル。ダーク専用、高密度データ、シアン/コーラルの売買シグナル。すべて2メートル離れた場所からひと目で読み取れる。',
  'uber': 'モビリティプラットフォーム。大胆なモノクロ、タイトな書体、都会的なエネルギー。',
  'urdu': 'ウルドゥー語を第一とするデジタル体験。ネイティブな RTL 対応、ナスタアリーク書体、二言語の調和を備える。',
  'vercel': 'フロントエンドのデプロイ。モノクロの精密さ、Geist フォント。',
  'vibrant': '生き生きとしたカラフルなデザイン。大胆で遊び心のある書体、温かみのあるアクセント、ダイナミックな視覚的エネルギー。',
  'vintage': '1950〜1990年代のノスタルジー。スキューモーフィックな要素、ざらついたテクスチャ、レトロなカラーパレット、ピクセル調の書体。',
  'vodafone': 'グローバルな通信ブランド。記念碑的な大文字ディスプレイ、Vodafone Red のチャプターバンド。',
  'voltagent': 'AI エージェントフレームワーク。漆黒のキャンバス、エメラルドのアクセント、ターミナルネイティブ。',
  'warm-editorial': 'セリフ主導のマガジン的な美学。温かみのあるオフホワイトの紙にテラコッタのアクセント —\n長文、エディトリアル、ブランド主導のマーケティングページに最適。',
  'warp': 'モダンなターミナル。ダークな IDE 風インターフェース、ブロックベースのコマンド UI。',
  'webex': 'コラボレーションプラットフォーム。躍動感のある書体、ブルーのアクションシステム、マルチユーザーのアクセントスペクトラム。',
  'webflow': 'ビジュアルな Web ビルダー。ブルーをアクセントにした、洗練されたマーケティングサイトの美学。',
  'wechat': 'WeChat ミニプログラム、公式アカウント、オープンエコシステム拡張のためのブランドビジュアル言語。',
  'wired': 'テックマガジン。ペーパーホワイトの新聞紙的な密度、カスタムセリフのディスプレイ、モノスペースのキッカー、インクブルーのリンク。',
  'wise': '送金サービス。明るいグリーンのアクセント、親しみやすく明快。',
  'x-ai': 'イーロン・マスクの AI 研究所。極端なモノクローム、未来的なミニマリズム。',
  'xiaohongshu': 'ライフスタイル UGC ソーシャルプラットフォーム。単一のブランドレッド、ゆったりとした角丸、コンテンツ第一。',
  'zapier': '自動化プラットフォーム。温かみのあるオレンジ、親しみやすいイラスト主導。',
};

export const JA_DESIGN_SYSTEM_CATEGORIES: Record<string, string> = {
  'AI & LLM': 'AI と LLM',
  'Automotive': '自動車',
  'Backend & Data': 'バックエンドとデータ',
  'Bold & Expressive': '大胆で表現力豊か',
  'Creative & Artistic': 'クリエイティブとアート',
  'Design & Creative': 'デザインとクリエイティブ',
  'Developer Tools': '開発者ツール',
  'E-Commerce & Retail': 'E コマースと小売',
  'Editorial & Print': 'エディトリアルと印刷',
  'Editorial / Personal / Publication': 'エディトリアル / パーソナル / 出版',
  'Editorial · Studio': 'エディトリアル · スタジオ',
  'Fintech & Crypto': 'フィンテックと暗号資産',
  'Layout & Structure': 'レイアウトと構造',
  'Media & Consumer': 'メディアとコンシューマー',
  'Modern & Minimal': 'モダンとミニマル',
  'Morphism & Effects': 'モーフィズムとエフェクト',
  'Productivity & SaaS': '生産性と SaaS',
  'Professional & Corporate': 'プロフェッショナルとコーポレート',
  'Retro & Nostalgic': 'レトロとノスタルジック',
  'Social & Messaging': 'ソーシャルとメッセージング',
  'Starter': 'スターター',
  'Themed & Unique': 'テーマ性・個性的',
};

export const JA_PROMPT_TEMPLATE_CATEGORIES: Record<string, string> = {
  'Advertising': '広告',
  'Anime': 'アニメ',
  'Anime / Manga': 'アニメ／マンガ',
  'App / Web Design': 'アプリ／Webデザイン',
  'Branding': 'ブランディング',
  'Cinematic': 'シネマティック',
  'Data': 'データ',
  'Game UI': 'ゲームUI',
  'General': '一般',
  'Illustration': 'イラストレーション',
  'Infographic': 'インフォグラフィック',
  'Live Artifact': 'ライブアーティファクト',
  'Marketing': 'マーケティング',
  'Motion Graphics': 'モーショングラフィックス',
  'Product': 'プロダクト',
  'Profile / Avatar': 'プロフィール／アバター',
  'Short Form': 'ショートフォーム',
  'Social / Meme': 'ソーシャル／ミーム',
  'Social Media Post': 'ソーシャルメディア投稿',
  'Travel': '旅行',
  'VFX / Fantasy': 'VFX／ファンタジー',
  'VFX / HTML-in-Canvas': 'VFX／HTML-in-Canvas',
};

export const JA_PROMPT_TEMPLATE_TAGS: Record<string, string> = {
  '3d': '3D',
  '3d-render': '3Dレンダリング',
  'action': 'アクション',
  'ancient-china': '古代中国',
  'anime': 'アニメ',
  'app-showcase': 'アプリショーケース',
  'archery': 'アーチェリー',
  'arpg': 'アクションRPG',
  'audio-reactive': 'オーディオリアクティブ',
  'boss-fight': 'ボス戦',
  'brand': 'ブランド',
  'branding': 'ブランディング',
  'captions': 'キャプション',
  'cavalry': '騎兵',
  'chart': 'チャート',
  'childlike': '子どもらしい',
  'choreography': '振付',
  'cinematic': 'シネマティック',
  'cinematic-romance': 'シネマティック・ロマンス',
  'combat': '戦闘',
  'combo': 'コンボ',
  'companion-to-image': 'コンパニオンから画像へ',
  'counter': 'カウンター',
  'crayon': 'クレヨン',
  'cyberpunk': 'サイバーパンク',
  'dance': 'ダンス',
  'dashboard': 'ダッシュボード',
  'data': 'データ',
  'data-viz': 'データ可視化',
  'destruction': '破壊',
  'displacement': 'ディスプレイスメント',
  'editorial': 'エディトリアル',
  'elden-ring': 'Elden Ring',
  'endcard': 'エンドカード',
  'escort': 'エスコート',
  'escort-mission': 'エスコートミッション',
  'fantasy': 'ファンタジー',
  'fashion': 'ファッション',
  'fighting-game': '格闘ゲーム',
  'food': 'フード',
  'game-cinematic': 'ゲームシネマティック',
  'game-ui': 'ゲームUI',
  'grid-sheet': 'グリッドシート',
  'guanyu': '関羽',
  'hand-drawn': '手描き',
  'hero': 'ヒーロー',
  'html-in-canvas': 'キャンバス内HTML',
  'hud': 'HUD',
  'hud-safe': 'HUDセーフ',
  'hype': 'ハイプ',
  'hyperframes': 'HyperFrames',
  'idol': 'アイドル',
  'illustration': 'イラストレーション',
  'image-to-image': '画像から画像へ',
  'infographic': 'インフォグラフィック',
  'iphone': 'iPhone',
  'japanese': '日本語',
  'karaoke': 'カラオケ',
  'key-visual': 'キービジュアル',
  'keynote': '基調講演',
  'kinetic-typography': 'キネティックタイポグラフィ',
  'linear-style': 'Linear風',
  'liquid': 'リキッド',
  'liquid-glass': 'リキッドグラス',
  'live-artifact': 'ライブアーティファクト',
  'logo': 'ロゴ',
  'lyubu': 'lyubu',
  'macbook': 'MacBook',
  'magnetic': 'マグネティック',
  'map': 'マップ',
  'marketing': 'マーケティング',
  'minimal': 'ミニマル',
  'mmo': 'MMO',
  'mobile': 'モバイル',
  'money': 'マネー',
  'mounted-combat': '騎乗戦闘',
  'nature': 'ネイチャー',
  'open-world': 'オープンワールド',
  'otaku-dance': 'オタ芸ダンス',
  'outro': 'アウトロ',
  'overlay': 'オーバーレイ',
  'particles': 'パーティクル',
  'pipeline': 'パイプライン',
  'portal': 'ポータル',
  'portrait': 'ポートレート',
  'pose-reference': 'ポーズ参照',
  'product': 'プロダクト',
  'product-demo': 'プロダクトデモ',
  'product-promo': 'プロダクトプロモ',
  'rework': 'リワーク',
  'route': 'ルート',
  'saas': 'SaaS',
  'sequence': 'シーケンス',
  'shader': 'シェーダー',
  'shatter': 'シャッター',
  'sizzle': 'シズル',
  'social': 'ソーシャル',
  'storyboard': '絵コンテ',
  'street-fighter': 'ストリートファイター',
  'style-transfer': 'スタイル転送',
  'tekken': '鉄拳',
  'text': 'テキスト',
  'three-kingdoms': '三国志',
  'tiktok': 'tiktok',
  'title-card': 'タイトルカード',
  'transform': '変換',
  'travel': '旅行',
  'tts': 'tts',
  'typography': 'タイポグラフィ',
  'unreal-engine-5': 'unreal-engine-5',
  'vertical': '縦型',
  'video-reference': '動画リファレンス',
  'vs-screen': '対戦画面',
  'webgl': 'webgl',
  'website-to-video': 'ウェブサイトから動画へ',
  'wuxia': '武侠',
  'zhaoyun': '趙雲',
};

export const JA_PROMPT_TEMPLATE_COPY: Record<string, Partial<Pick<PromptTemplateSummary, 'summary' | 'title'>>> = {
  '3d-stone-staircase-evolution-infographic': {
    title: '3D石階進化インフォグラフィック',
    summary:
      '平面的な進化のタイムラインを、精緻な生物のレンダリングと構造化されたサイドパネルを備えたリアルな3D石階のインフォグラフィックに変換します。',
  },
  'anime-martial-arts-battle-illustration': {
    title: 'アニメ武術バトルイラスト',
    summary:
      '伝統的な道場で2人の女性キャラクターが属性エネルギーエフェクトを伴って戦う、ダイナミックでインパクトの強いアニメイラストを生成します。',
  },
  'e-commerce-live-stream-ui-mockup': {
    title: 'ECライブ配信UIモックアップ',
    summary:
      'ポートレートに重ねたリアルなソーシャルメディアのライブ配信インターフェースを生成します。カスタマイズ可能なチャットメッセージ、ギフトのポップアップ、商品購入カードを備えています。',
  },
  'game-screenshot-anime-fighting-game-captain-ryuuga-vs-kaze-renshin': {
    title: 'ゲームスクリーンショット - アニメ格闘ゲーム：キャプテン・リューガ vs カゼ・レンシン',
    summary:
      'Street Fighter 6 や Tekken 8 のイントロアートのスタイルによる、ゲーム内の格闘ゲームキービジュアル／戦闘スクリーンショット。ドラマチックな夜の中国寺院の中庭の中央で、アニメ風の2人の男性戦士が対峙する。左側は温かなオレンジレッドの炎のオーラをまとう上半身裸の麦わら帽子の海賊、右側はオレンジ色の道着を着てトゲトゲ髪の武術家が、巨大でバチバチと弾ける青い雷のエネルギー球をチャージしている。完全な格闘ゲームHUD（デュアルヘルスバー、ラウンドタイマー、名前とエンブレム付きのP1/P2ポートレートパネル、各サイドのコンボカウンターとマックスゲージ）を備える。温かいオレンジ vs クールな青のスプリットカラーグレーディングが、このジャンルのライバルファイターの慣習にマッチする。gpt-image-2 の 16:9 向けに調整済み。',
  },
  'game-screenshot-three-kingdoms-guanyu-slaying-yanliang': {
    title: 'ゲームスクリーンショット - 三国志ARPG：関羽、顔良を斬る',
    summary:
      '関羽が愛馬・赤兎馬に跨り、豪雨の戦場を駆け抜けて敵将・顔良に突進する、三国志の象徴的な場面を描いたゲーム内アクションRPGスクリーンショット。Black Myth: Wukong のシネマティックなフォトリアルスタイル、Unreal Engine 5 でレンダリングし、騎乗した英雄の後方左からの三人称追従カメラを採用。完全なボス戦HUD（ポートレート、密集した敵ドット付きのミニマップ、フィニッシャープロンプト付きのスキルホットバー、敵将に浮かぶボスHPバー）が、この場面をAAA級ARPGの戦闘シーンへと昇華させる。gpt-image-2 の 16:9 向けに調整済み。',
  },
  'game-screenshot-three-kingdoms-lyubu-yuanmen-archery': {
    title: 'ゲームスクリーンショット - 三国志ARPG：呂布の轅門射戟',
    summary:
      '呂布が陣営の門に立てた遠くの戟を射抜いて戦を止める、三国志の有名な場面を描いたゲーム内アクションRPGスクリーンショット。Black Myth: Wukong のシネマティックなフォトリアルスタイル、Unreal Engine 5 の Nanite/Lumen でレンダリングし、三人称オーバーザショルダーのゲームプレイカメラを採用。完全なゲーム内HUDオーバーレイ（HP＋気のバー、ミニマップ、スキルホットバー、遠くの戟までの距離表示付きロックオンターゲットマーカー）により、カットシーンではなく本物の次世代ARPGのキャプチャーとして読み取れる。gpt-image-2 の 16:9 向けに調整済み。',
  },
  'game-screenshot-three-kingdoms-zhaoyun-cradle-escape': {
    title: 'ゲームスクリーンショット - 三国志ARPG：長坂坡における趙雲の阿斗救出',
    summary:
      '長坂坡で趙雲が片腕に幼子・劉禅を抱え、もう片方の腕で槍を振るって敵陣を切り開く、三国志の伝説的な場面を描いたゲーム内アクションRPGスクリーンショット。Black Myth: Wukong と Elden Ring を融合させたシネマティックなフォトリアルスタイル、完全な Nanite、Lumen レイトレーシング、ボリュメトリックな天使の梯子を備えた Unreal Engine 5 でレンダリング。感情の核心——片腕で産着の赤子を守り、もう片方の腕で命をかけて戦う——は、赤子専用のESCORT保護バー、コンボカウンター、吹き飛ばされた敵への空中ダメージ数値のポップアップを含む完全なHUDオーバーレイによって強調される。gpt-image-2 の 16:9 向けに調整済み。',
  },
  'game-ui-ancient-china-open-world-mmo-hud': {
    title: 'ゲームUI - 古代中国オープンワールドMMOのHUD',
    summary:
      'Black Myth: Wukong のシネマティックなフォトリアルスタイルによる、AAA級の古代中国オープンワールドMMO向けのゲーム内HUDスクリーンショットモックアップを生成します。霧深い山中の古い祠の場面で、美しい女性剣士の主人公がフレーム中央を据え、完全なMMOのHUDに囲まれます。左上にHP/MP/スタミナバーとバフアイコン付きのキャラクターポートレート、下部中央に中国書道風のスキルアイコンを並べたスキルホットバー、右上にクエストマーカー付きのミニマップ、右側にクエストトラッカーパネル、左下にスクロール式チャットウィンドウ、ワールド空間に浮かぶNPCネームプレートとクエストの感嘆符を配置。リアルなモニターのスクリーンショットとして 16:9 でレンダリングし、ピッチデック、gamescom風のキーアート、小紅書/bilibili のゲームティザーに適しています。',
  },
  'illustrated-city-food-map': {
    title: 'イラスト風シティグルメマップ',
    summary:
      '番号付きの地元グルメ名物、ランドマーク、凡例を備えた手描きの水彩風観光マップを生成します。',
  },
  'illustration-crayon-kid-drawing-rework': {
    title: 'イラスト - クレヨン子ども絵リワーク',
    summary:
      '任意の参照画像（商品写真、スクリーンショット、ポートレート、UIモックアップ）を、10歳の子どもが描いたような手描きのクレヨンイラストに作り変えるスタイル転写プロンプト。元のパレットを、清潔な白い紙に明るく遊び心のあるクレヨンの色に置き換え、お城、お菓子、星、雲、虹といった子どもらしい無邪気さを散りばめて、純真な絵本のような雰囲気を高めます。GPT-image-2 での image-to-image 編集として機能します（プロンプトと一緒に参照画像のアップロードが必要）。ウェブサイトのスクリーンショット、ブランドのキービジュアル、商品写真、ポートレートに最適です。',
  },
  'infographic-otaku-dance-choreography-breakdown-gokurakujodo-16-panels': {
    title: 'インフォグラフィック - オタク芸ダンス振付解説（極楽浄土、16パネル）',
    summary:
      '16個の連結した正方形パネルを4×4のグリッドで構成した、縦長2:3のポスター1枚。有名な日本のオタク芸ダンス曲「極楽浄土」の完全な振付解説チャートを形成します。各パネルには、同じ可愛い半リアル系アニメアイドル少女（ピンクのツインテール、セーラーカラーのスクールアイドル衣装）が、ダンスの代表的なポーズを全身で1つ披露し、パステルピンクの背景に、下部には小さな日本語のキャプション帯、左上には番号付きの丸が配置されています。AI動画生成のための「ポーズ参照」シートとして明確に設計されており、すべてのシルエットは鮮明で曖昧さがなく、動きの線や背景の雑然としたものはありません。gpt-image-2 向けに調整、アスペクト比2:3。カテゴリ：インフォグラフィック。',
  },
  'momotaro-explainer-slide-in-hybrid-style': {
    title: 'ハイブリッドスタイルの桃太郎解説スライド',
    summary:
      'いらすとやイラストのシンプルで温かみのある美学と、日本の官公庁スライドに特徴的な高い情報密度を組み合わせたプロンプト。',
  },
  'notion-team-dashboard-live-artifact': {
    title: 'Notion風チームダッシュボード（ライブアーティファクト）',
    summary:
      '1画面構成の Notion ネイティブなチームダッシュボードのモックアップ — KPIグリッド、7日間のスパークライン、アクティビティフィード、リンクされたデータベースのタスクテーブル。ライブアーティファクトスキルのビジュアル版です。更新可能 / コネクター連携の実行と組み合わせるか、静止モックアップとして単独で使用できます。',
  },
  'profile-avatar-anime-girl-to-cinematic-photo': {
    title: 'プロフィール / アバター - アニメ少女からシネマティック写真へ',
    summary:
      'このプロンプトは、キャラクター参照イラストを、元の衣装、ポーズ、猫を保持したまま、リアルで温かみのあるトーンのヴィンテージ室内ポートレートに変換します。',
  },
  'profile-avatar-casual-fashion-grid-photoshoot': {
    title: 'プロフィール / アバター - カジュアルファッションのグリッド撮影',
    summary:
      '詳細な被写体とライティングのパラメータを備えた、カジュアルファッション撮影の4枚写真コラージュ用の構造化された JSON プロンプト。',
  },
  'profile-avatar-cinematic-south-asian-male-portrait-with-vultures': {
    title: 'プロフィール / アバター - ハゲワシを伴う南アジア系男性のシネマティックポートレート',
    summary:
      'ハゲワシとワタリガラスに囲まれた、ムーディーでダークなファンタジー設定の若い南アジア系男性の詳細なシネマティックポートレート。',
  },
  'profile-avatar-cyberpunk-anime-portrait-with-neon-face-text': {
    title: 'プロフィール / アバター - 顔にネオン文字を施したサイバーパンク・アニメポートレート',
    summary:
      'ポスター、ソーシャルメディアアート、または未来的なブランディングビジュアル向けの、スタイリッシュでネオンに満ちたアニメポートレート。',
  },
  'profile-avatar-elegant-fantasy-girl-in-violet-garden': {
    title: 'プロフィール / アバター - 紫の庭園の優雅なファンタジー少女',
    summary:
      'このプロンプトは、艶やかにスタイリングされた髪、華麗な紫黒の衣装、花で満たされた魔法の庭園を背景にした、優雅な女性の洗練されたアニメ風ファンタジーポートレートを生成します。キャラクターに最適',
  },
  'profile-avatar-ethereal-blue-haired-fantasy-portrait': {
    title: 'プロフィール / アバター - 幻想的な青髪のファンタジーポートレート',
    summary:
      'このプロンプトは、柔らかく輝くアニメ風のファンタジーキャラクターポートレートを生成します。流れるような髪と夢のような春の雰囲気を備えた、優雅な縦長キービジュアルやキャラクターイラストの作成に最適です。',
  },
  'profile-avatar-glamorous-woman-in-black-portrait': {
    title: 'プロフィール / アバター - 黒い衣装の華やかな女性ポートレート',
    summary:
      'このプロンプトは、深いVネックの黒い衣装をまとった優雅な女性のフォトリアリスティックなラグジュアリースタイルのポートレートを生成します。ファッションエディトリアルやビューティーイメージに最適です。',
  },
  'profile-avatar-hyper-realistic-selfie-texture-prompts': {
    title: 'プロフィール / アバター - 超リアルなセルフィーのテクスチャプロンプト',
    summary:
      'リアルな肌の質感と本物らしいスマホのセルフィー構図を生成するための詳細なプロンプトスニペット。目に見える毛穴と自然なライティングに焦点を当てています。',
  },
  'profile-avatar-lavender-fantasy-mage-portrait': {
    title: 'プロフィール / アバター - ラベンダーのファンタジー魔法使いポートレート',
    summary:
      'このプロンプトは、艶やかなブロンドの髪、紫の花、華麗なクリスタルの衣装をまとった優雅な魔法使いの姫の洗練されたアニメ風ファンタジーポートレートを生成します。キャラクターアートや魔法のイラストに最適',
  },
  'profile-avatar-monochrome-studio-portrait': {
    title: 'プロフィール / アバター - モノクロのスタジオポートレート',
    summary:
      '特徴的な分割背景と劇的なスタジオライティングを備えたモノクロポートレート用の、ハイエンドなコマーシャルフォトプロンプト。',
  },
  'profile-avatar-old-photo-restoration-to-dslr-portrait': {
    title: 'プロフィール / アバター - 古い写真をデジタル一眼レフのポートレートに復元',
    summary:
      'このプロンプトは、損傷したヴィンテージの4人家族写真を、写真修復・補正のために、クリーンでカラー化された高解像度のリアルなポートレートに復元します。',
  },
  'profile-avatar-poetic-woman-in-garden-portrait': {
    title: 'プロフィール / アバター - 庭園の詩的な女性ポートレート',
    summary:
      'このプロンプトは、陽光の差し込む庭園にいる読書好きの若い女性のリアルなエディトリアル風ポートレートを生成します。ライフスタイル写真、文学的なブランディング、優雅なキャラクターイメージに最適です。',
  },
  'profile-avatar-professional-identity-portrait-wallpaper': {
    title: 'プロフィール / アバター - プロフェッショナルなアイデンティティのポートレート壁紙',
    summary:
      'プロフェッショナルな服装の被写体を、キャリアに関連したアクティビティとタイポグラフィとともに描いた、高解像度のプレミアム壁紙を生成します。',
  },
  'profile-avatar-realistically-imperfect-ai-selfie': {
    title: 'プロフィール / アバター - リアルに不完全な AI セルフィー',
    summary:
      '偶然撮ったような低画質のスマホスナップに見える「失敗した」セルフィーを生成するために GPT Image 2 と併用するクリエイティブなプロンプト。',
  },
  'profile-avatar-signed-marker-portrait-on-shikishi': {
    title: 'プロフィール / アバター - 色紙にサイン入りマーカーポートレート',
    summary:
      'これは、正方形の色紙にサイン入りのマーカー風ポートレートを生き生きと生成します。ファンアートのサイン、記念イラストの投稿、パーソナライズされたお礼ビジュアルに役立ちます。',
  },
  'profile-avatar-snow-rabbit-empress-portrait': {
    title: 'プロフィール / アバター - 雪兎の女帝ポートレート',
    summary:
      '雪山の寺院を背景に立つ、華麗な冬の漢服をまとった気品ある兎モチーフの女性を生成するための、リアルなファンタジーポートレートプロンプト。',
  },
  'profile-avatar-snow-rabbit-mask-hanfu-portrait': {
    title: 'プロフィール / アバター - 雪兎の仮面と漢服のポートレート',
    summary:
      'ウサギをテーマにした白い漢服をまとった仮面の女性を描いた、映画のような冬のファンタジーポートレートを生成するプロンプト。エレガントなキャラクターアートや雰囲気のあるAIショーケース画像に最適です。',
  },
  'profile-avatar-snowy-rabbit-hanfu-portrait': {
    title: 'プロフィール / アバター - 雪ウサギ漢服ポートレート',
    summary:
      '刺繍を施した漢服をまとうウサギ耳の女性を描いた、超精細なファンタジー美少女ポートレートを生成するプロンプト。エレガントなキャラクターアート、衣装デザイン、映画のようなAIポートレートのショーケースに最適です。',
  },
  'profile-avatar-snowy-rabbit-spirit-portrait': {
    title: 'プロフィール / アバター - 雪ウサギの精霊ポートレート',
    summary:
      '冬を背景にした匿名のウサギ耳の女性を描いた、静謐なファンタジーポートレートを生成するプロンプト。雰囲気のあるキャラクターアートやスタイライズされたプロフィールイラストに最適です。',
  },
  'profile-avatar-song-dynasty-hanfu-portrait': {
    title: 'プロフィール / アバター - 宋朝漢服ポートレート',
    summary:
      '古い中庭を背景に、宋朝の伝統的な漢服をまとう美女の精細でリアルなポートレートを生成するための最適化されたプロンプト。',
  },
  'social-media-post-anime-pokemon-shop-outfit-teaser-poster': {
    title: 'ソーシャルメディア投稿 - アニメ風Pokémonショップ衣装ティザーポスター',
    summary:
      'Pokémonストア店内で青いドレスを着た顔をぼかした少女を描いた、柔らかなパステルカラーのアニメ風ファッション告知ポスターを生成するプロンプト。衣装お披露目ティザーやキャラクタープロモーションビジュアルに最適です。',
  },
  'social-media-post-cinematic-elevator-scene': {
    title: 'ソーシャルメディア投稿 - 映画のようなエレベーターシーン',
    summary:
      '金属製のエレベーター内にいる女性を、リアルなライティングと反射で描いた、ムーディで映画のようなシーンを生成するためのプロンプト。',
  },
  'social-media-post-confused-elf-girl-at-pastel-desk': {
    title: 'ソーシャルメディア投稿 - パステルデスクで困惑するエルフの少女',
    summary:
      '居心地のよいカワイイ作業空間でコンピューターをタイピングするエルフの少女を描いた、柔らかなパステルカラーのアニメイラストを生成するプロンプト。ソーシャル投稿、壁紙、配信者をテーマにしたアートに最適です。',
  },
  'social-media-post-editorial-fashion-photography': {
    title: 'ソーシャルメディア投稿 - エディトリアルファッション写真',
    summary:
      '柔らかなライティングと暖かなトーンを備えた、ミニマリストなスタジオシーンを描いた、ムーディでファッションに焦点を当てたプロンプト。',
  },
  'social-media-post-fashion-editorial-collage': {
    title: 'ソーシャルメディア投稿 - ファッションエディトリアルコラージュ',
    summary:
      'ファッションエディトリアル撮影向けの、非常に精細な2x2フォトコラージュプロンプト。一貫したスタイリング、特定のライティング、参照写真からの顔の特徴に焦点を当てています。',
  },
  'social-media-post-psg-transfer-announcement-poster': {
    title: 'ソーシャルメディア投稿 - PSG移籍発表ポスター',
    summary:
      '選手のParis Saint-Germainへの移籍をソーシャルメディアやスポーツプロモーショングラフィックで発表するための、大胆でプロフェッショナルなサッカー契約ポスター。',
  },
  'social-media-post-sensational-girl-dance-storyboard-8-shots': {
    title: 'ソーシャルメディア投稿 - センセーショナルな少女のダンスストーリーボード(8カット)',
    summary:
      'スタイリッシュなキャラクターの一貫したフレームごとのダンスシーケンスを生成するための、8カットのフルストーリーボードプロンプトセット。共通のグローバルスタイルトークン、再利用可能なネガティブプロンプト、そしてカットごとの8つのプロンプト(オープニングポーズ、ヒップグルーヴ、ボディウェーブ、ビートドロップでのウエストツイスト、サイドヒップスウェイ、ヘアフリック、パワースタンス、フィニッシングポーズ)を含みます。GPT-Image-2ティアのモデル向けに調整されており、簡潔な語彙、センシティブな表現を避け、カット間で一貫したフレーミングとライティング表現により、フレームがひとつの連続した振付のように感じられます。',
  },
  'social-media-post-showa-day-retro-culture-magazine-cover': {
    title: 'ソーシャルメディア投稿 - 昭和の日レトロカルチャー雑誌表紙',
    summary:
      'アニメキャラクターアート、ノスタルジックな昭和時代の街並みイメージ、雑誌風の情報レイアウトを組み合わせた、季節の文化プロモーション向けの暖かなエディトリアル風の日本の祝日特集ページ。',
  },
  'social-media-post-social-media-fashion-outfit-generation': {
    title: 'ソーシャルメディア投稿 - ソーシャルメディア向けファッションコーディネート生成',
    summary:
      'キャラクタープロフィールに基づき、アイテムのラベルと価格付きで、1週間分のファッションブロガー風コーディネート提案を生成するプロンプト。',
  },
  'social-media-post-travel-snapshot-collage-prompt': {
    title: 'ソーシャルメディア投稿 - 旅行スナップショットコラージュプロンプト',
    summary:
      '一人旅を描いた、スマートフォン風の旅行写真12フレームのノスタルジックなコラージュを作成するための、詳細なプロンプト。',
  },
  'social-media-post-vintage-sign-painter-sketch': {
    title: 'ソーシャルメディア投稿 - ヴィンテージ看板職人風スケッチ',
    summary:
      '鉛筆の線やインクのにじみといったリアルなディテールを備えた、紙に描かれた手描きのマーカースケッチを生成します。ヴィンテージなレタリングスタイルに最適です。',
  },
  'vr-headset-exploded-view-poster': {
    title: 'VRヘッドセット分解図ポスター',
    summary:
      '詳細な部品の説明と宣伝テキストを備えた、VRヘッドセットのハイテクな分解図ダイアグラムを生成します。',
  },
  '3d-animated-boy-building-lego': {
    title: 'レゴを組み立てる3Dアニメーションの少年',
    summary:
      '部屋でレゴのパーツを丁寧に組み立てる少年を描いた、タイムラプス効果を特徴とする3Dアニメーションスタイルのマルチショット動画プロンプト。',
  },
  'a-decade-of-refinement-glow-up': {
    title: '10年の磨き上げによるグローアップ',
    summary:
      'キャラクターの一貫性を保ちながら、男性が2016年のカジュアルな設定から2026年の豪華なドバイのライフスタイルへと変貌する様子を描いた、Seedance 2.0向けのトランスフォーメーションプロンプト。',
  },
  'ancient-guardian-dragon-rescue': {
    title: '古代の守護竜による救出',
    summary:
      '雨の村で、現れた竜に救われる少女の物語を描いた、VFXと雰囲気のあるサウンドに焦点を当てた、詳細なマルチショットの映画的プロンプト。',
  },
  'ancient-indian-kingdom-fpv-video': {
    title: '古代インド王国FPV動画',
    summary:
      '寺院やジャングルのある神秘的なインド王国を描いた、テンポの速いFPVドローン風の映画的プロンプト。',
  },
  'animation-transfer-and-camera-tracking-prompt': {
    title: 'アニメーション転送とカメラトラッキングのプロンプト',
    summary:
      '固定カメラトラッキングを維持しながら、特定のモーションリファレンスをキャラクターに適用する Seedance 2.0 向けの技術的なプロンプト。',
  },
  'beat-synced-outfit-transformation-dance': {
    title: 'ビート同期の衣装チェンジダンス',
    summary:
      'ブレイクダウンフレームに沿ったキャラクターダンスを、ビート同期の衣装チェンジと連動させて演出する Seedance 2.0 向けプロンプト。',
  },
  'character-intro-motion-graphics-sequence': {
    title: 'キャラクター紹介モーショングラフィックスシーケンス',
    summary:
      'Seedance 2.0 モデル向けに設計された、特定の UI オーバーレイとトランジションを用いてキャラクターチームを紹介する、複雑で多段階のモーショングラフィックスプロンプト。',
  },
  'cinematic-birthday-celebration-sequence': {
    title: 'シネマティックなバースデー祝賀シーケンス',
    summary:
      'キャラクターの一貫性と感情的なストーリーテリングに焦点を当てた、バースデーシーケンス向けの非常に詳細なマルチショット動画プロンプト。',
  },
  'cinematic-dragon-interaction-flight': {
    title: 'シネマティックなドラゴンとの交流＆飛行',
    summary:
      '女性がドラゴンと感情的に交流し、その後にシネマティックな飛行シーンが続く動画のための、詳細なストーリーボード形式のプロンプト。',
  },
  'cinematic-east-asian-woman-hand-dance': {
    title: 'シネマティックな東アジア人女性のハンドダンス',
    summary:
      'カメラの動きとキャラクターのアクションをタイムコードで指示する、様式化されたハンドダンス向けの非常に詳細なマルチショットシネマティック動画プロンプト。',
  },
  'cinematic-emotional-face-close-up': {
    title: 'シネマティックで感情的な顔のクローズアップ',
    summary:
      'リアルな肌の質感と、一連の複雑な感情的表情の変化に焦点を当てた Seedance 2.0 向けの非常に詳細な技術プロンプト。',
  },
  'cinematic-marine-biologist-exploration': {
    title: 'シネマティックな海洋生物学者の探検',
    summary:
      'サンゴ礁の中で古代の難破船を発見する海洋生物学者を描いた水中シーン向けの、詳細なシネマティック動画プロンプト。',
  },
  'cinematic-music-podcast-and-guitar-technique': {
    title: 'シネマティックな音楽ポッドキャストとギターテクニック',
    summary:
      'ギターテクニック、ピンチハーモニクス、スタジオの美学に重点を置いた、4K 音楽ポッドキャスト動画を生成するための高度なシネマティックプロンプト。',
  },
  'cinematic-route-navigation-guide': {
    title: 'シネマティックなルートナビゲーションガイド',
    summary:
      '繰り返し登場するツアーガイドのキャラクターと、現実世界のロケーション間のスムーズなトランジションを特徴とする、一貫したウォーキングナビゲーション動画を作成するために Seedance 向けに設計された、構造化されたマルチシーンプロンプト。',
  },
  'cinematic-street-racing-sequence-for-seedance-2': {
    title: 'Seedance 2 向けのシネマティックなストリートレースシーケンス',
    summary:
      '夜のシネマティックなストリートレースシーケンスを生成するために Seedance 2 向けに設計された、ドライバーの集中、ダイナミックなカメラワーク、爆発的な加速に焦点を当てた、詳細でマルチショットのプロンプト。構造',
  },
  'cinematic-vampire-alley-fight-sequence': {
    title: 'シネマティックな吸血鬼の路地戦闘シーケンス',
    summary:
      'ネオンに照らされた路地でのダイナミックなカメラの動きと高速戦闘を含む短編映画シーン向けの、包括的なアクションプロンプト。',
  },
  'crimson-horizon-sci-fi-cinematic-sequence': {
    title: 'クリムゾン・ホライズン SF シネマティックシーケンス',
    summary:
      'ロケットの打ち上げから火星での不気味なエイリアンとの遭遇まで、あらゆる場面を詳細に描いた、SF 映画『Crimson Horizon』向けの包括的な 9 ショットのシネマティック動画シーケンス。',
  },
  'cyberpunk-game-trailer-script': {
    title: 'サイバーパンクゲームトレーラースクリプト',
    summary:
      'キャラクターデザイン、UI アニメーション、そして白いボイドからファベーラへの環境トランジションを詳細に描いた、サイバーパンクゲームトレーラー向けの広範な動画生成プロンプト。',
  },
  'forbidden-city-cat-satire': {
    title: '紫禁城の猫風刺',
    summary:
      '風刺的な清王朝の舞台でオレンジの猫の役人とハイエナの皇帝を登場させる、Seedance 2.0 向けの複雑なブラックコメディプロンプト。',
  },
  'hollywood-haute-couture-fantasy-video-prompt': {
    title: 'ハリウッド・オートクチュール・ファンタジー動画プロンプト',
    summary:
      'ハリウッド・オートクチュール・ファンタジー映画を作成するために設計された、Seedance 2.0 向けの詳細なマルチシーン動画生成プロンプト。このプロンプトはスタイル、解像度（8K）、レンダリングエンジン（Unreal Engin）を指定する。',
  },
  'hunched-character-animation': {
    title: '前かがみのキャラクターアニメーション',
    summary:
      '特定のキャラクターリファレンスに対してその場で歩くアニメーションを作成するための Seedance 2 向けの指示。',
  },
  'hyperframes-html-in-canvas-iphone-device': {
    title: 'HyperFrames HTML-in-Canvas: 3D iPhone + MacBook プロダクトデモ',
    summary:
      '実物の GLTF iPhone 15 Pro Max と MacBook Pro がクリーンなステージに浮かび、その画面上には drawElementImage を介して実際のアプリ UI がライブでレンダリングされる 15 秒のプロダクトデモ。モーフィングするガラスのレンズフレア + 360° ターンテーブル。vfx-iphone-device カタログブロックをベースに構築。',
  },
  'hyperframes-html-in-canvas-text-cursor': {
    title: 'HyperFrames HTML-in-Canvas: シネマティックなテキストカーソルリビール',
    summary:
      '黒いステージ上で、カーソルのグロー、色収差のシャドウレイ、指向性ライティングを伴う 8 秒のドラマチックなテキストリビール。ライブシェーダーのポストプロセッシング下にある実物の DOM タイポグラフィ。vfx-text-cursor カタログブロックをベースに構築。',
  },
  'hyperframes-html-in-canvas-shatter': {
    title: 'HyperFrames HTML-in-Canvas: ガラスシャッターアウトロ',
    summary:
      '12 秒の HTML シャッターアウトロ — 実物のプロダクトページや料金カードが一拍静止した後、深度ブラーと色分散を伴って屈折するガラスの破片へと爆発する。vfx-shatter カタログブロックをベースに構築。長尺コンポジションの後のエンドカードとして組み合わせられる。',
  },
  'hyperframes-html-in-canvas-liquid-background': {
    title: 'HyperFrames HTML-in-Canvas: リキッドバックグラウンドヒーロー',
    summary:
      'オーガニックな液体表面の上に HTML コンテンツが浮かぶ12秒のヒーロー映像 — 頂点変位を加えた細分化平面、リアルタイムの波動、キャプチャした DOM が上面で鮮明かつ読みやすく動きます。vfx-liquid-background カタログブロックをベースに構築。',
  },
  'hyperframes-html-in-canvas-liquid-glass': {
    title: 'HyperFrames HTML-in-Canvas: リキッドグラスのランディングリビール',
    summary:
      '実際のプロダクトのランディングページを20秒のボロノイ・リキッドグラスで演出するリビール — DOM を drawElementImage でライブキャプチャし、屈折するガラスセルに砕いた後、クリーンなヒーローショットへと収束します。vfx-liquid-glass カタログブロックをベースに構築。',
  },
  'hyperframes-html-in-canvas-magnetic': {
    title: 'HyperFrames HTML-in-Canvas: 磁場ビジュアライゼーション',
    summary:
      'ライブな DOM ヒートマップやチャートに反応する15秒の磁場パーティクルビジュアライゼーション — パーティクルがキャプチャした HTML を回り込む磁力線を描き、ML/データ系プロダクトに最適です。vfx-magnetic カタログブロックをベースに構築。',
  },
  'hyperframes-html-in-canvas-portal-reveal': {
    title: 'HyperFrames HTML-in-Canvas: ポータルリビールダッシュボード',
    summary:
      '次元ポータルが10秒でライブデータダッシュボードへと開く — DOM をリアルタイムにキャプチャし、ボリュメトリックな光のあふれとポータルエッジのパーティクルを表現。vfx-portal カタログブロックをベースに構築。キーノート風のデータヒーローショット向けに設計されています。',
  },
  'hyperframes-money-counter-hype': {
    title: 'HyperFrames: $0 → $10K マネーカウンター・ハイプ (9:16)',
    summary:
      '6秒の縦型 1080×1920 HyperFrames ハイプクリップ — Apple 風の $0 → $10,000 カウンターに、グリーンフラッシュ、紙幣が弾けるパーティクル、札束アイコン、キャッチコピー見出しを添えて。HyperFrames の `apple-money-count` カタログブロックをベースに構築。',
  },
  'hyperframes-app-showcase-three-phones': {
    title: 'HyperFrames: 12秒のアプリショーケース — 浮遊する3台のフォン',
    summary:
      '12秒の 16:9 アプリショーケース構成 — 3台の iPhone 画面が3D空間に浮遊し、それぞれ順番に回転して異なる機能を見せ、ビートに同期したラベルコールアウトとエンドロゴのロックアップを表現。HyperFrames の `app-showcase` カタログブロックをそのままベースに構築。',
  },
  'hyperframes-brand-sizzle-reel': {
    title: 'HyperFrames: 30秒のブランドシズルリール',
    summary:
      '30秒の 16:9 HyperFrames シズルリール — 高速カット、ビート同期のキネティックタイポグラフィ、ディスプレイワードへのオーディオ反応スケール、5つのシーン間のシェーダートランジション、ロゴブルームのエンドカード。スチューデントキットの aisoc-hype アーキタイプをモデルに構築。',
  },
  'hyperframes-saas-product-promo-30s': {
    title: 'HyperFrames: 30秒の SaaS プロダクトプロモ (Linear 風)',
    summary:
      'Linear/ClickUp 風のプロダクトフィルムをモデルにした30秒の HyperFrames 構成 — UI の3Dリビール、ビート同期のキネティックタイポグラフィ、アニメーションする UI スクリーンショット、ロゴアウトロのエンドカード。HF カタログブロック (ui-3d-reveal、app-showcase、logo-outro) とシーン間のシェーダートランジションで構築。',
  },
  'hyperframes-logo-outro-cinematic': {
    title: 'HyperFrames: 4秒のシネマティックロゴアウトロ',
    summary:
      '4秒の 16:9 ロゴアウトロ — ブルームを伴うピースごとのワードマーク組み立て、最終ロックアップを横切るシマースイープ、ソフトなグレインオーバーレイ、1行の CTA。HyperFrames の `logo-outro`、`shimmer-sweep`、`grain-overlay` ブロックをベースに構築。',
  },
  'hyperframes-product-reveal-minimal': {
    title: 'HyperFrames: 5秒のミニマルなプロダクトリビール',
    summary:
      'ハイエンドなプロダクトリビールのための5秒の HyperFrames 構成 — 暗いキャンバス、単一のウォームアクセント、ゆっくりとプッシュインするタイトルカード、キネティックなキャッチコピー、抑制されたモーション。エージェントは puppeteer 経由で HTML+GSAP から MP4 をレンダリングし、ストック素材は不要です。',
  },
  'hyperframes-social-overlay-stack': {
    title: 'HyperFrames: 9:16 ソーシャルオーバーレイスタック (X · Reddit · Spotify · Instagram)',
    summary:
      'フェイスカムループの上に4枚のアニメーションするソーシャルカードを重ねる15秒の縦型 1080×1920 HyperFrames 構成 — X の投稿、Reddit のリアクション、Spotify の再生中カード、そして最後に Instagram フォローの CTA。各カードは HyperFrames のカタログブロックで、その演出構成が付加価値です。',
  },
  'hyperframes-tiktok-karaoke-talking-head': {
    title: 'HyperFrames: 9:16 TikTok トーキングヘッド + カラオケ字幕',
    summary:
      '縦型 1080×1920 の HyperFrames ショート — フェイスカムループの上に TTS ナレーションのトーキングヘッドを重ね、カラオケ風の単語同期字幕、アニメーションする下三分の一テロップ、最後に tiktok-follow オーバーレイを表示。HyperFrames スチューデントキットの may-shorts-19 アーキタイプを踏襲しています。',
  },
  'hyperframes-data-bar-chart-race': {
    title: 'HyperFrames: アニメーション棒グラフレース (NYT 風)',
    summary:
      '12秒の 16:9 データインフォグラフィック — カテゴリーが段階的に現れるアニメーション棒グラフ＋折れ線グラフ、NYT 風のセリフ見出し、脚注の出典、キネティックな数値ラベル。HyperFrames の `data-chart` カタログブロックをそのままベースに構築。',
  },
  'hyperframes-flight-map-route': {
    title: 'HyperFrames: Apple 風フライトマップ (出発地 → 目的地)',
    summary:
      '8秒の 16:9 シネマティックなフライトルートマップ — リアルな地形ズーム、曲線パスに沿って出発地から目的地へ滑空するアニメーションの飛行機、ラベル付きの都市、キネティックな距離カウンター。HyperFrames の `nyc-paris-flight` カタログブロックをそのままベースに構築し、任意の都市ペアに転用可能です。',
  },
  'hyperframes-website-to-video-promo': {
    title: 'HyperFrames: ウェブサイトから動画へのパイプライン (15秒のマーケティングカット)',
    summary:
      'ライブのウェブサイトを3種類のビューポートサイズでキャプチャし、シーン間をクロマチックな放射状スプリットでアニメーションさせる15秒の 16:9 HyperFrames 構成。サイトをソースアセットとする hyperframes-sizzle スチューデントキットのアーキタイプを踏襲しています。',
  },
  'live-action-anime-adaptation-water-vs-thunder-breathing-duel': {
    title: '実写アニメ化: 水の呼吸 vs 雷の呼吸の決闘',
    summary:
      'アニメ風の決闘を実写化するための、非常に詳細な15秒のプロンプト。「水の呼吸」(青い水の龍) 対「雷の呼吸」(黄金の稲妻) をフィーチャーしています。p',
  },
  'luxury-supercar-cinematic-narrative': {
    title: '高級スーパーカーのシネマティックなナラティブ',
    summary:
      'スタイリッシュな男性、ドーベルマン、そして霧深い山中のヴィンテージスーパーカーを盛り込んだ、Seedance 2.0 向けの非常に詳細なマルチショットのシネマティックプロンプト。',
  },
  'magical-academy-storyboard-sequence': {
    title: '魔法学園のストーリーボードシーケンス',
    summary:
      '学園の魔法少女を描くシネマティックなシーケンスのための詳細なストーリーボード形式のプロンプト。到着、力の発見、そして魔法の決闘までをカバーします。',
  },
  'modern-rural-aesthetics-healing-short-film-video-prompt': {
    title: 'モダンな田園美学のヒーリングショートフィルム動画プロンプト',
    summary:
      'モダンな田園美学スタイルのヒーリングでシネマティックなショートフィルムを生成するための、Seedance 2.0 向けの詳細な3ショットプロンプト。スタイル (シネマティックコマーシャル、4K/8K、極端なマクロ、ナチュラル) を指定します。',
  },
  'nightclub-flyer-atmospheric-animation': {
    title: 'ナイトクラブのフライヤー風アトモスフェリックアニメーション',
    summary:
      '被写体を固定したまま背景とライティングの要素に命を吹き込む、Seedance 2.0 向けの繊細なアニメーションプロンプト。',
  },
  'retro-hk-wuxia-film-aesthetic': {
    title: 'レトロな香港武侠映画の美学',
    summary:
      '80〜90年代の香港武侠映画の美学を再現する、複数パートから成る複雑な動画プロンプト。スタイライズされたショットで、猫から人間へのキャラクター変身を描く。',
  },
  'seedance-2-0-15-second-cinematic-japanese-romance-short-film': {
    title: 'Seedance 2.0：15秒のシネマティックな日本の恋愛ショートフィルム',
    summary:
      'シネマティックで超リアルな日本の高校純愛ショートフィルムを生成するために設計された、Seedance 2.0向けの詳細な15秒マルチシーンプロンプト。プロンプトはシーン設定（誰もいない',
  },
  'seedance-2-0-80-year-old-rapper-mv': {
    title: 'Seedance 2.0：80歳のラッパーのMV',
    summary:
      '80歳の女性を主役にした16:9横型ストリートラップミュージックビデオ（MV）を生成するための、Seedance 2.0向けの詳細な15秒プロンプト。プロンプトはスタイル（ネオンパープル/ブルーのクールトーン、exp',
  },
  'sequence-and-movement-instruction-for-martial-arts-video': {
    title: '武術動画のためのシーケンスと動作の指示',
    summary:
      'キャラクターシートに基づいてシーケンスをアニメーション化するようモデルに指示する、Seedance 2.0向けの動画プロンプト。特定の動きとステップに焦点を当てる。',
  },
  'soul-switching-mirror-magic-sequence': {
    title: '魂が入れ替わる鏡のマジックシーケンス',
    summary:
      '鏡の前で魂が入れ替わる魔法のような出来事を描いたナラティブ動画プロンプト。各セグメントに特定のカメラ指示と感情的なキューを盛り込む。',
  },
  'toaster-rocket-jumpscare': {
    title: 'トースターロケットのびっくり演出',
    summary:
      'トースターがパンをロケットのように発射し、老人が驚かされるリアルなホームビデオ風ショットのプロンプト。',
  },
  'traditional-dance-performance': {
    title: '伝統舞踊のパフォーマンス',
    summary:
      '振付とアイデンティティのリファレンス画像に基づいて優雅な伝統舞踊を生成するための、Seedance 2.0向けの包括的な動画プロンプト。',
  },
  'video-seedance-three-kingdoms-guanyu-slaying-yanliang': {
    title: '動画 - 三国志ARPG - 関羽が顔良を斬る（Seedance 2.0）',
    summary:
      'コンパニオン画像テンプレート game-screenshot-three-kingdoms-guanyu-slaying-yanliang を映像化する、約10秒のインエンジン・シネマティックアクションシーケンス。関羽（关羽）が赤兎馬に乗って敵の戦列へ真っ直ぐ突進し、青龍偃月刀を振り上げ、敵将・顔良を一閃で斬り捨てる。Seedance 2.0向けに調整 — 厳格なカメラ制御、決定的な一撃、クリーンな馬と刀の物理表現、フォトリアルなライティング、画面上に流血表現は一切なし（一撃は金色の気のフラッシュで暗示し、血では表現しない）。対応する画像テンプレートの直接的な動画コンパニオンとして設計されており、静止画とクリップをペアとして提供できる。リファレンス画像：関羽が顔良を斬るスクリーンショットテンプレート。',
  },
  'video-seedance-three-kingdoms-lyubu-yuanmen-archery': {
    title: '動画 - 三国志ARPG - 呂布の轅門射戟（Seedance 2.0）',
    summary:
      'コンパニオン画像テンプレート game-screenshot-three-kingdoms-lyubu-yuanmen-archery を映像化する、約10秒のインエンジン・シネマティックアクションシーケンス。呂布（吕布）が対峙する二つの軍勢の間、砂塵舞う軍営の中央に立ち、赤漆塗りの長弓を引き、満を持して構え、地面に立てられた遠くの戟に向けて金色に輝く気を込めた一矢を放つ。Seedance 2.0向けに調整 — 厳格なカメラ制御、決定的な一拍、HUDセーフでくっきりとしたフレーミング、クリーンな弓矢の物理表現、風・砂塵・軍旗の動き、ゲーム内スクリーンショット風のカラーグレーディング。対応する画像テンプレートの直接的な動画コンパニオンとして設計されており、静止画とクリップをペアとして提供できる。リファレンス画像：呂布の轅門射戟スクリーンショットテンプレート。',
  },
  'video-seedance-three-kingdoms-zhaoyun-cradle-escape': {
    title: '動画 - 三国志ARPG - 趙雲の幼子救出（Seedance 2.0）',
    summary:
      'コンパニオン画像テンプレート game-screenshot-three-kingdoms-zhaoyun-cradle-escape を映像化する、約12秒のインエンジン・シネマティックアクションシーケンス。趙雲（赵云）が荒廃した長坂の戦場を軍馬で駆け抜け、左腕に幼い世継ぎ阿斗を抱え、右手に槍を構え、襲い来る一撃を一度の完璧な回避（PERFECT DODGE）でかわし、倒れた戦車を飛び越えて活路を切り開く。Seedance 2.0向けに調整 — 厳格なカメラ制御、途切れのない一拍、説得力のある片手槍術、クリーンな馬の物理表現、幼子には一切危害が及ぶ描写なし。対応する画像テンプレートの直接的な動画コンパニオンとして設計されており、静止画とクリップをペアとして提供できる。リファレンス画像：趙雲の幼子救出スクリーンショットテンプレート。',
  },
  'vintage-disney-style-pirate-crocodile-animation': {
    title: 'ヴィンテージDisney風の海賊ワニのアニメーション',
    summary:
      '船上のワニの海賊と鳥の海賊たちを描いた、クラシックなヴィンテージDisney風アニメーションのためのマルチシーン・ナラティブプロンプト。',
  },
  'viral-k-pop-dance-choreography': {
    title: 'バズるK-popダンスの振付',
    summary:
      '16コマのストーリーボードリファレンスに基づき、キャラクターがダンスを披露する様子をアニメーション化するための、Seedance 2.0向けの詳細なプロンプト。',
  },
  'wasteland-factory-chase': {
    title: '荒廃した工場でのチェイス',
    summary:
      '脚で歩く移動式の工業工場と反乱軍のバイクチェイスを描いた、高速の砂漠荒野シーンのためのシネマティックプロンプト。',
  },
};
